<template>
    <div>
        <!-- มือถือ + ?code + ยังไม่ login: แสดงรายละเอียดแบบการ์ด | login แล้ว: แสดงตารางค้นหา -->
        <ExtinguisherDetails
            v-if="showMobileDetailsView"
            :logged-in="isLoggedIn"
            @edit-request="onQrEditRequest"
        />

        <div v-show="!showMobileDetailsView">
        <Fieldset :legend="$t('searchHeader')" :toggleable="true">
            <div class="p-fluid p-mt-2 p-ml-3 p-mr-3 p-mb-2" @keyup.enter="saveData_Modal('search')">
                <div class="p-formgrid p-grid p-col">
                    <div class="p-field p-col-12 p-lg-3 p-mt-2">
                        <label for="extinguisher_size">{{ 'ขนาดถังดับเพลิง' }}</label>
                        <InputText
                            id="extinguisher_size"
                            type="text"
                            v-model="extinguisher_size"
                            ref="TextBox_1_search"
                            @keyup.left="moveFocus($event, 'TextBox_7_search', 'Button')"
                            @keyup.right="moveFocus($event, 'TextBox_2_search', 'Input')"
                            @keyup.down="moveFocus($event, 'TextBox_5_search', 'Input')"
                        />
                    </div>

                    <div class="p-field p-col-12 p-lg-3 p-mt-2">
                        <label for="place_name">{{ 'ประเภทถังดับเพลิง' }}</label>

                        <Dropdown
                            id="type"
                            v-model="type"
                            :options="FireExtinguisherOptions_AT_extinguisher"
                            optionLabel="fs_tname"
                            ref="TextBox_2_search"
                            :filter="true"
                            :placeholder="$t('placeholderSelectBox')"
                            :clearFilterDropdown="dropdownClearFilerValue"
                        >
                            <template #value="FireExtinguisherOptions_AT_extinguisher">
                                <div v-if="FireExtinguisherOptions_AT_extinguisher.value">
                                    <div>{{ FireExtinguisherOptions_AT_extinguisher.value }}</div>
                                </div>
                            </template>
                            <template #option="FireExtinguisherOptions_AT_extinguisher">
                                <div>{{ FireExtinguisherOptions_AT_extinguisher.option }}</div>
                            </template>
                        </Dropdown>
                    </div>

                    <div class="p-field p-col-12 p-lg-3 p-mt-2">
                        <label for="place_name">{{ $t('iex_place_name') }}</label>
                        <InputText
                            id="place_name"
                            type="text"
                            v-model="place_name"
                            ref="TextBox_3_search"
                            @keyup.left="moveFocus($event, 'TextBox_1_search', 'Button')"
                            @keyup.right="moveFocus($event, 'TextBox_3_search', 'Button')"
                            @keyup.up="moveFocus($event, 'TextBox_1_search', 'Button')"
                            @keyup.down="moveFocus($event, 'TextBox_3_search', 'Button')"
                        />
                    </div>

                    <div class="p-field p-col-12 p-lg-3 p-mt-2">
                        <label for="type">{{ 'ประเภทสถานที่' }}</label>

                        <InputText
                            id="location_type"
                            type="text"
                            v-model="location_type"
                            ref="TextBox_4_search"
                            @keyup.left="moveFocus($event, 'TextBox_1_search', 'Button')"
                            @keyup.right="moveFocus($event, 'TextBox_3_search', 'Button')"
                            @keyup.up="moveFocus($event, 'TextBox_1_search', 'Button')"
                            @keyup.down="moveFocus($event, 'TextBox_3_search', 'Button')"
                        />
                    </div>
                </div>

                <div class="p-formgrid p-grid p-col p-mt-1">
                    <div class="p-field p-col-12 p-lg-3 p-mt-2">
                        <label for="provinceOptions">{{ $t('province') }}</label>
                        <Dropdown
                            v-model="selectedProvince"
                            :options="provinceOptions"
                            optionLabel="province_name"
                            :filter="true"
                            :placeholder="$t('placeholderSelectBox')"
                            :showClear="true"
                            :clearFilterDropdown="dropdownClearFilerValue"
                        >
                            <template #value="provinceOptions">
                                <div v-if="provinceOptions.value">
                                    <div>{{ provinceOptions.value.province_name }}</div>
                                </div>
                            </template>
                            <template #option="provinceOptions">
                                <div>{{ provinceOptions.option.province_name }}</div>
                            </template>
                        </Dropdown>
                    </div>

                    <div class="p-field p-col-12 p-lg-3 p-mt-2">
                        <label for="amphurOptions">{{ $t('amphur') }}</label>
                        <Dropdown
                            :disabled="isDisabledAmphur == 1"
                            v-model="selectedAmphur"
                            :options="amphurOptions"
                            optionLabel="amphur_name"
                            :filter="true"
                            :placeholder="$t('placeholderSelectBox')"
                            :showClear="true"
                            :clearFilterDropdown="dropdownClearFilerValue"
                        >
                            <template #value="amphurOptions">
                                <div v-if="amphurOptions.value">
                                    <div>{{ amphurOptions.value.amphur_name }}</div>
                                </div>
                            </template>
                            <template #option="amphurOptions">
                                <div>{{ amphurOptions.option.amphur_name }}</div>
                            </template>
                        </Dropdown>
                    </div>

                    <div class="p-field p-col-12 p-lg-3 p-mt-2">
                        <label for="tambonOptions">{{ $t('tambon') }}</label>
                        <Dropdown
                            :disabled="isDisabledTambon == 1"
                            v-model="selectedTambon"
                            :options="tambonOptions"
                            optionLabel="tambon_name"
                            :filter="true"
                            :placeholder="$t('placeholderSelectBox')"
                            :showClear="true"
                            :clearFilterDropdown="dropdownClearFilerValue"
                        >
                            <template #value="tambonOptions">
                                <div v-if="tambonOptions.value">
                                    <div>{{ tambonOptions.value.tambon_name }}</div>
                                </div>
                            </template>
                            <template #option="tambonOptions">
                                <div>{{ tambonOptions.option.tambon_name }}</div>
                            </template>
                        </Dropdown>
                    </div>

                    <!-- Doe เพิ่ม สถานีดับเพลิงและกู้ภัย -->
                    <!-- <div class="p-field p-col-12 p-lg-3 p-mt-2" 
               v-if="!selectedProvince &&
                     !selectedAmphur &&
                     !selectedTambon">
            <label for="FireStationOptions">{{ $t("ira_FireStation") }} </label>
            <Dropdown
              
              v-model="FireStationSelected"
              :options="FireStationOptions"
              optionLabel="fs_tname"
              :filter="true"
              :placeholder="$t('placeholderSelectBox')"
              :showClear="true"
              :clearFilterDropdown="dropdownClearFilerValue"
            >
              <template #value="FireStationOptions">
                <div v-if="FireStationOptions.value">
                  <div>{{ FireStationOptions.value.fs_tname }}</div>
                </div>
              </template>
              <template #option="FireStationOptions">
                <div>{{ FireStationOptions.option.fs_tname }}</div>
              </template>
            </Dropdown>
          </div> -->
                    <!-- <div class="p-field p-col-12 p-lg-3 p-mt-2" v-else> -->
                    <div class="p-field p-col-12 p-lg-3 p-mt-2">
                        <label for="FireStationOptions">{{ $t('ira_FireStation') }} </label>
                        <Dropdown
                            v-model="FireStationSelected"
                            :options="FireStationOptions_AT"
                            optionLabel="fs_tname"
                            :filter="true"
                            :placeholder="$t('placeholderSelectBox')"
                            :showClear="true"
                            :clearFilterDropdown="dropdownClearFilerValue"
                        >
                            <template #value="{ value, placeholder }">
                                <div v-if="value">
                                    <div>{{ value.fs_tname }}</div>
                                </div>
                                <span v-else>
                                    {{ placeholder }}
                                </span>
                            </template>
                            <template #option="{ option }">
                                <div>{{ option.fs_tname }}</div>
                            </template>
                        </Dropdown>
                    </div>
                </div>

                <div class="p-formgrid p-grid p-col p-mt-1">
                    <div class="p-field p-col-12 p-lg-3 p-mt-2">
                        <label for="ife_extinguisher_code">{{ 'หมายเลขประจำถัง' }}</label>
                        <InputText
                            id="ife_extinguisher_code"
                            type="text"
                            v-model="ife_extinguisher_code"
                            ref="TextBox_1_search"
                            @keyup.left="moveFocus($event, 'TextBox_7_search', 'Button')"
                            @keyup.right="moveFocus($event, 'TextBox_2_search', 'Input')"
                            @keyup.down="moveFocus($event, 'TextBox_5_search', 'Input')"
                        />
                    </div>

                    <div class="p-field p-col-12 p-lg-3 p-mt-2">
                        <label for="iex_extinguisher_status_search">{{ 'สถานะการตรวจสอบ' }}</label>
                        <Dropdown
                            id="iex_extinguisher_status_search"
                            v-model="iex_extinguisher_status_search"
                            :options="iex_extinguisher_status_search_options"
                            optionLabel="value"
                            ref="TextBox_2_search"
                            :filter="true"
                            :placeholder="$t('placeholderSelectBox')"
                            :clearFilterDropdown="dropdownClearFilerValue"
                        >
                            <template #value="iex_extinguisher_status_search_options">
                                <div v-if="iex_extinguisher_status_search_options.value">
                                    <div>{{ iex_extinguisher_status_search_options.value }}</div>
                                </div>
                            </template>
                            <template #option="iex_extinguisher_status_search_options">
                                <div>{{ iex_extinguisher_status_search_options.option }}</div>
                            </template>
                        </Dropdown>
                    </div>

                    <div class="p-field p-col-12 p-lg-3 p-mt-2">
                        <label for="ifh_community_name">{{ 'ชุมชน' }}</label>
                        <Dropdown
                            v-model="community_name"
                            :options="communityOptions"
                            optionLabel="community_name"
                            :dataKey="'community_id'"
                            :filter="true"
                            :placeholder="$t('placeholderSelectBox')"
                            :showClear="true"
                            :clearFilterDropdown="dropdownClearFilerValue"
                        >
                            <template #value="slotProps">
                                <div v-if="slotProps.value">
                                    <div>{{ slotProps.value.community_name }}</div>
                                </div>
                                <span v-else>
                                    {{ slotProps.placeholder }}
                                </span>
                            </template>

                            <template #option="slotProps">
                                <div class="EV_communityOptions">
                                    {{ slotProps.option.community_name }}
                                </div>
                            </template>
                        </Dropdown>
                    </div>
                    <div class="p-field p-col-12 p-lg-3 p-mt-2">
                        <label>{{ 'สถานะ' }}</label>
                        <Dropdown
                            v-model="status_code"
                            :options="['ปกติ', 'ชำรุด']"
                            :filter="true"
                            :placeholder="$t('placeholderSelectBox')"
                            :showClear="true"
                            :clearFilterDropdown="dropdownClearFilerValue"
                        >
                        </Dropdown>
                    </div>
                </div>
                <div class="p-formgrid p-grid p-col p-mt-1" v-if="isAdmin">
                    <div class="p-field p-col-12 p-lg-3 p-mt-2">
                        <label>{{ $t('starttime') }}</label>
                        <Calendar
                            dateFormat="dd/mm/yy"
                            :maxDate="end_date"
                            :showButtonBar="true"
                            :monthNavigator="true"
                            :yearNavigator="true"
                            yearRange="2000:2050"
                            placeholder="วัน/เดือน/ปี"
                            :locale="th"
                            v-model="start_date"
                        ></Calendar>
                    </div>
                    <div class="p-field p-col-12 p-lg-3 p-mt-2">
                        <label>{{ $t('endtime') }}</label>
                        <Calendar
                            dateFormat="dd/mm/yy"
                            :showButtonBar="true"
                            :monthNavigator="true"
                            :yearNavigator="true"
                            yearRange="2000:2050"
                            placeholder="วัน/เดือน/ปี"
                            :locale="th"
                            v-model="end_date"
                        ></Calendar>
                    </div>
                    <div class="p-field p-col-12 p-lg-3 p-mt-2">
                        <label>ประเภทข้อมูล</label>
                        <Dropdown
                            v-model="filter_date_field"
                            :options="[
                                { name: 'เลือกทั้งหมด', value: null },
                                { name: 'วันที่สร้างข้อมูล', value: 'date_created' },
                                { name: 'วันที่ปรับปรุงข้อมูล', value: 'date_update' }
                            ]"
                            optionLabel="name"
                            optionValue="value"
                            :dataKey="'value'"
                            :filter="true"
                            :placeholder="$t('placeholderSelectBox')"
                            :showClear="true"
                            :clearFilterDropdown="dropdownClearFilerValue"
                        >
                        </Dropdown>
                    </div>
                </div>

                <div class="p-formgrid p-grid p-col p-mt-1">
                    <div class="p-field p-col">
                        <div class="p-formgrid p-grid p-jc-end p-mt-5">
                            <!-- Doe โหลด โทรศัพท์ -->
                            <Button
                                v-if="window.width <= 430"
                                @click="MobileClearSearchField()"
                                :label="$t('clearBtn')"
                                class="p-button-clear p-ml-3 p-mr-3"
                                ref="TextBox_6_search"
                                @keyup.left="moveFocus($event, 'TextBox_5_search', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_7_search', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_4_search', 'Input')"
                            />
                            <Button
                                v-else
                                @click="clearSearchField()"
                                :label="$t('clearBtn')"
                                class="p-button-clear p-ml-3 p-mr-3"
                                ref="TextBox_6_search"
                                @keyup.left="moveFocus($event, 'TextBox_5_search', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_7_search', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_4_search', 'Input')"
                            />
                            <!-- Doe โหลด โทรศัพท์ -->
                            <Button
                                @click="searchFireHydrant()"
                                :label="$t('searchBtn')"
                                class="p-button-info"
                                ref="TextBox_7_search"
                                @keyup.left="moveFocus($event, 'TextBox_6_search', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_8_search', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_4_search', 'Input')"
                            />
                            <!-- <Button
                    @click="fastSearchFireHydrant()"
                    :label="$t('fastSearchBtn')"
                    class="p-button-danger p-ml-3"
                    ref="TextBox_8_search"
                    @keyup.left="moveFocus($event, 'TextBox_7_search','Button')"
                    @keyup.right="moveFocus($event, 'TextBox_1_search','Input')"
                    @keyup.up="moveFocus($event, 'TextBox_4_search','Input')"
                    style="width: 160px; display: inline-block;"
                  /> -->
                        </div>
                    </div>
                </div>
                <div class="p-formgrid p-grid p-col p-mt-1">
                    <text-footer :data="Data_text_Footer" :checkShow="text_Footer" :countItem="FireHydrant_Table.length.toLocaleString('en-US')" />
                </div>
            </div>
        </Fieldset>
        <div class="card p-fluid p-mt-2">
            <!-- Doe : เพิ่ม ลำดับ 1/4   sortField="index" :sortOrder="1" -->
            <DataTable
                :value="columns_disabled ? FireHydrant_Table : []"
                scrollHeight="500px"
                :lazy="true"
                :paginator="true"
                :rows="lazyParams.rows"
                :totalRecords="lazyParams.totalRecords"
                :first="lazyParams.first"
                @page="onPage"
                sortField="index"
                :sortOrder="1"
                dataKey="fx_id"
                ref="dt"
                :exportFilename="`ข้อมูลถังดับเพลิง-${date}`"
                :rowHover="true"
                :selection.sync="selectedFireHydrant"
                :filters="filters"
                :loading="loading"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[10, 20, 50]"
                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
            >
                <!-- Doe : เพิ่ม ลำดับ 1/4   sortField="index" :sortOrder="1" จบ-->
                <template #header>
                    <div class="p-grid p-col">
                        <div class="table-header" id="Create" style="padding: 7px" v-if="checkAdd_data != 'false'">
                            <Button @click="FireHydrantModal = true" :label="$t('addBtn')" class="p-button-success" />
                        </div>

                        <!-- Doe : PDF 1/3 -->
                        <div class="table-header" id="EX" style="padding: 7px">
                            <Button @click="exportCSV()" :label="$t('exportBtn')" style="background-color: green" />
                        </div>
                        <div class="table-header" id="PDF" style="padding: 7px">
                            <SplitButton
                                label="ส่งออก PDF"
                                :model="items"
                                class="p-button-raised p-button-danger"
                                style="background-color: #f33737"
                            ></SplitButton>
                        </div>
                        <!-- Doe : PDF 1/3 จบ -->

                        <!-- Doe PDF เลือกได้  1/5   -->
                        <div class="table-header" id="TABLE_EDIT" style="padding: 7px">
                            <Button
                                @click="EditPDF()"
                                icon="pi pi-cog"
                                :label="'ตั้งค่า'"
                                style="background-color: #0288d1; border: 1px solid #0288d1"
                            />
                        </div>

                        <div class="table-header" id="TABLE_EDIT" style="padding: 7px" v-if="selectedFireHydrant && selectedFireHydrant.length > 0">
                            <Button
                                @click="updateDates()"
                                icon="pi pi-cog"
                                :label="'ปรับปรุงข้อมูล'"
                                style="background-color: #fab12f; border: 1px solid #fab12f"
                            />
                        </div>
                        <GenerateExtinguisherModal
                            :visible="showGenerateModal"
                            @update:visible="showGenerateModal = $event"
                            @generated="onExtinguisherGenerated"
                        />
                        <AssignOrganizationModal
                            :visible="showAssignModal"
                            @update:visible="showAssignModal = $event"
                            @assigned="onOrganizationAssigned"
                        />
                        <QRCodeGenerator :visible="showQrcodeModal" @update:visible="showQrcodeModal = $event" />
                        <div class="table-header" style="padding: 7px" v-if="isAdmin">
                            <Button
                                @click="showGenerateModal = true"
                                icon="pi pi-plus"
                                :label="'สร้างข้อมูลถังดับเพลิง (ถังเปล่า)'"
                                style="background-color: #0288d1; border: 1px solid #0288d1"
                            />
                        </div>

                        <div class="table-header" style="padding: 7px" v-if="isAdmin">
                            <Button
                                @click="showAssignModal = true"
                                icon="pi pi-plus"
                                :label="'ผูกหน่วยงานกับถังดับเพลิง (ถังเปล่า)'"
                                style="background-color: #a855f7; border: 1px solid #a855f7"
                            />
                        </div>

                        <div class="table-header" style="padding: 7px" v-if="isAdmin">
                            <Button
                                @click="showQrcodeModal = true"
                                icon="pi pi-plus"
                                :label="'สร้าง QR Code ของถังดับเพลิง'"
                                style="background-color: #f97316; border: 1px solid #f97316"
                            />
                        </div>

                        <!-- Doe PDF เลือกได้  1/5 จบ  -->

                        <div class="table-header p-col-12 p-lg-3" id="Search" style="margin-left: auto">
                            <!-- <span class="p-input-icon-left">
                <i class="pi pi-search" /><InputText
                  v-model="filters['global']"
                  :placeholder="$t('searchHeader')"
                />
              </span> -->

                            <!-- Doe ค้นหา  1/5 -->

                            <span class="p-input-icon-left" v-if="columns_disabled">
                                <i class="pi pi-search" />
                                <InputText v-model="filter" @input="search" :placeholder="$t('searchHeader')" ref="searchInput" />
                            </span>
                            <span class="p-input-icon-left" v-else>
                                <i class="pi pi-search" />
                                <InputText disabled v-model="filter" :placeholder="$t('searchHeader')" />
                            </span>

                            <!-- Doe ค้นหา  1/5 จบ-->
                        </div>
                    </div>
                </template>

                <Column :headerStyle="tableColSticky('8rem', 'center', 'sticky', 'top')">
                    <template #header>
                        <div v-if="columns_disabled">
                            <input
                                style="width: 20px; height: 20px"
                                type="checkbox"
                                :checked="selectedFireHydrant.length === FireHydrant_Table.length"
                                @change="onSelectAll($event.target.checked)"
                            />
                        </div>
                    </template>
                    <template #body="slotProps">
                        <div class="table_row" v-if="columns_disabled">
                            <input
                                style="width: 20px; height: 20px"
                                type="checkbox"
                                :checked="selectedFireHydrant.some((item) => item.fx_id === slotProps.data.fx_id)"
                                @change="onSelectRow(slotProps.data, $event.target.checked)"
                            />
                        </div>
                    </template>
                </Column>

                <template #empty>{{ $t('TableEmpty') }}</template>
                <div v-if="columns_index == true">
                    <Column field="index" :header="'ลำดับ'" :headerStyle="tableColSticky('8rem', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_index == true">
                                {{ dataTable.data.index }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>
                <!--Doe : เพิ่มลำดับ 2/4 จบ-->
                <div v-if="columns_img_cloud == true">
                    <Column field="" :header="'รูปภาพ'" :headerStyle="tableColSticky('15rem', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_img_cloud == true">
                                <div
                                    v-if="
                                        dataTable.data.image_cloud !== '-' &&
                                        dataTable.data.image_cloud !== '' &&
                                        dataTable.data.image_cloud !== null &&
                                        dataTable.data.image_cloud !== 'undefined' &&
                                        dataTable.data.image_cloud !== undefined &&
                                        columns_img_cloud == true
                                    "
                                >
                                    <img
                                        :src="pickRecordImage(dataTable.data, 'image_cloud')"
                                        @click="showImage(pickRecordImageRaw(dataTable.data, 'image_cloud'))"
                                        alt=""
                                        style="height: 112px; max-width: 240px"
                                    />
                                </div>

                                <div v-else>-</div>
                            </div>
                        </template>
                    </Column>
                </div>

                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_genqr == true">
                    <Column field="" :header="'QR Code'" :headerStyle="tableColSticky('15rem', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_genqr == true">
                                <div
                                    v-if="
                                        dataTable.data.code !== '-' &&
                                        dataTable.data.code !== '' &&
                                        dataTable.data.code !== null &&
                                        dataTable.data.code !== 'undefined' &&
                                        dataTable.data.code !== undefined &&
                                        columns_genqr == true
                                    "
                                >
                                    <Button
                                        @click="genQrCode(dataTable.data.code)"
                                        icon="pi pi-image"
                                        :label="table_genQR"
                                        class="p-button-rounded p-button-info"
                                    />
                                </div>

                                <div v-else>-</div>
                            </div>
                        </template>
                    </Column>
                </div>

                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_place_name == true">
                    <Column field="place_name" :header="$t('iex_place_name')" :headerStyle="tableColSticky('150px', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_place_name == true">
                                {{ dataTable.data.place_name }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_code == true">
                    <Column field="code" :header="$t('iex_code_name')" :headerStyle="tableColSticky('180px', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_code == true">
                                {{ dataTable.data.code }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_type == true">
                    <Column field="type" :header="$t('iex_type')" :headerStyle="tableColSticky('150px', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_type == true">
                                {{
                                    dataTable.data.type == 'null' || dataTable.data.type == null || dataTable.data.type == ''
                                        ? '-'
                                        : dataTable.data.type
                                }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_extinguisher_size == true">
                    <Column
                        field="fire_extinguisher_size"
                        :header="$t('iex_extinguisher_size')"
                        :headerStyle="tableColSticky('180px', 'center', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_extinguisher_size == true">
                                {{ dataTable.data.fire_extinguisher_size }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_status == true">
                    <Column field="status" :header="$t('status_check')" :headerStyle="tableColSticky('180px', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_status == true">
                                {{ dataTable.data.status }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_status_organize == true">
                    <Column field="statusOrganize" :header="$t('status')" :headerStyle="tableColSticky('150px', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div
                                class="table_row"
                                v-if="columns_status_organize == true"
                                :style="{ color: dataTable.data.statusOrganize === 'ชำรุด' ? 'red' : 'inherit' }"
                            >
                                {{ dataTable.data.statusOrganize }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_location_type == true">
                    <Column field="location_type" :header="$t('iex_location_type')" :headerStyle="tableColSticky('150px', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_location_type == true">
                                {{ dataTable.data.location_type }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_amphur == true">
                    <Column field="country" :header="'เขต/อำเภอ'" :headerStyle="tableColSticky('150px', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_amphur == true">
                                {{ dataTable.data.country }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_tambon == true">
                    <Column field="subdistrict" :header="'แขวง/ตำบล'" :headerStyle="tableColSticky('150px', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_tambon == true">
                                {{ dataTable.data.subdistrict }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_community_name == true">
                    <Column field="community_name" :header="'ชุมชน'" :headerStyle="tableColSticky('150px', '', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div v-if="columns_community_name == true">
                                {{ dataTable.data.community_name }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_lat == true">
                    <Column field="lat" :header="'ละติจูด'" :headerStyle="tableColSticky('150px', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_lat == true">
                                {{ dataTable.data.lat }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_lon == true">
                    <Column field="lon" :header="'ลองจิจูด'" :headerStyle="tableColSticky('150px', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_lon == true">
                                {{ dataTable.data.lon }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_fire_station == true">
                    <Column field="fire_station" :header="'หน่วยงานรับผิดชอบ'" :headerStyle="tableColSticky('200px', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_fire_station == true">
                                {{ dataTable.data.fire_station }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_details == true">
                    <Column field="details" :header="'รายละเอียดข้อมูล'" :headerStyle="tableColSticky('200px', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_details == true">
                                {{ dataTable.data.details }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_date_expire == true">
                    <Column field="date_expire" :header="'วันหมดอายุ'" :headerStyle="tableColSticky('200px', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_date_expire == true">
                                {{ dataTable.data.date_expire }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_date_created == true">
                    <Column field="date_created" :header="'วันที่สร้างข้อมูล'" :headerStyle="tableColSticky('200px', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_date_created == true">
                                {{ dataTable.data.date_created }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_date_update == true">
                    <Column field="date_update" :header="'วันที่ปรับปรุงข้อมูล'" :headerStyle="tableColSticky('200px', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_date_update == true">
                                {{ dataTable.data.date_update }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_create_by_fullname == true">
                    <Column field="create_by_fullname" :header="'ผู้สร้างข้อมูล'" :headerStyle="tableColSticky('200px', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_create_by_fullname == true">
                                {{ dataTable.data.create_by_fullname }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_edit_by_fullname == true">
                    <Column field="edit_by_fullname" :header="'ผู้แก้ไขข้อมูล'" :headerStyle="tableColSticky('200px', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_edit_by_fullname == true">
                                {{ dataTable.data.edit_by_fullname }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div
                    v-if="
                        columns_img ||
                        columns_img_cloud ||
                        columns_genqr ||
                        columns_place_name ||
                        columns_code ||
                        columns_type ||
                        columns_status ||
                        columns_status_organize ||
                        columns_location_type ||
                        columns_amphur ||
                        columns_tambon ||
                        columns_community_name ||
                        columns_lat ||
                        columns_lon ||
                        columns_details ||
                        columns_date_created ||
                        columns_date_expire ||
                        columns_date_update ||
                        columns_create_by_fullname ||
                        columns_edit_by_fullname ||
                        columns_update_by ||
                        columns_fire_station ||
                        columns_extinguisher_size
                    "
                >
                    <Column
                        :header="$t('controlTable')"
                        :headerStyle="table_headerStyle"
                        :bodyStyle="table_bodyStyle"
                        v-if="checkEdit_data != 'false' || checkDelete_data != 'false'"
                    >
                        <template #body="dataTable">
                            <!-- <div class="p-formgrid" v-if="checkNotAdminPermission(dataTable.data.user_organize)"> -->
                            <div class="p-formgrid" v-if="checkDiv14()">
                                <div class="p-formgrid col_manege">
                                    <div :class="table_BOXmanege" v-if="checkEdit_data != 'false'">
                                        <!-- FireHydrantModal = true; -->
                                        <Button
                                            @click="
                                                editData(dataTable.data.fx_id);
                                                temp = dataTable.data.fx_id;
                                            "
                                            icon="pi pi-pencil"
                                            :label="table_editBTN"
                                            class="p-button-rounded p-button-warning"
                                        />
                                    </div>
                                    <div :class="table_BOXmanege" v-if="checkDelete_data != 'false'">
                                        <Button
                                            @click="
                                                // displayConfirmation = true;
                                                temp = dataTable.data.fx_id;

                                                alertDisplay(temp);
                                            "
                                            icon="pi pi-trash"
                                            :label="table_deleteBTN"
                                            class="p-button-rounded p-button-danger"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                {{ 'ไม่มีสิทธิ์จัดการข้อมูลนี้' }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column headerStyle="width: 0"></Column>
                </div>
            </DataTable>
        </div>
        </div>

        <!-- Manage data (อยู่นอก v-show เพื่อให้เปิดได้บนมือถือเมื่อสแกน QR) -->
        <Dialog
            :modal="true"
            :visible.sync="FireHydrantModal"
            :style="{ width: '85%' }"
            :header="header"
            id="dialog_ifh"
            :closable="loadingCreate ? false : true"
            :contentStyle="{ overflow: 'auto' }"
        >
            <div class="confirmation-content" @keyup.enter="saveData_Modal('Modal_Main')">
                <!-- โหลดเพิ่มแก้ไข 1/8-->
                <div class="From_Loading" v-if="loadingCreate" style="top: 38%">
                    <ProgressSpinner style="width: 120px; height: 120px; color: red" strokeWidth="5" animationDuration="1s" />
                    <div class="waveTextAnimated">
                        <span>กำ</span>
                        <span>ลัง</span>
                        <span>บัน</span>
                        <span>ทึก</span>
                        <span>ข้อ</span>
                        <span>มูล</span>
                        <!-- กำลังบันทึกข้อมูล -->
                    </div>
                </div>
                <!-- โหลดเพิ่มแก้ไข 1/8 จบ-->
                <label>{{ $t('ira_modal_subtitle') }}</label>
                <div class="p-fluid p-mt-5">
                    <!-- <div class="p-formgrid p-grid"> -->
                    <div class="p-formgrid p-grid" style="display: flex; justify-content: space-between">
                        <div class="p-field p-col-12 p-lg-1 p-mt-2">
                            <label for="ira_location_name">{{ 'ขนาดถัง' }} <span class="required-input">*</span></label>
                            <InputText
                                id="iex_extinguisher_size"
                                type="text"
                                v-model="iex_extinguisher_size"
                                required="true"
                                autofocus
                                :class="{
                                    'p-invalid': error_iex_extinguisher_size && !iex_extinguisher_size
                                }"
                                @input="acceptNumberPhone"
                                ref="TextBox_1"
                                @keyup.left="moveFocus($event, 'TextBox_12', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_2', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_4', 'Input')"
                            />
                            <small class="p-invalid" v-if="error_iex_extinguisher_size && !iex_extinguisher_size">{{ 'กรุณาระบุขนาด' }}</small>
                        </div>

                        <div class="p-field p-col-12 p-lg-2 p-mt-2">
                            <label for="ira_location_name">{{ 'หมายเลขประจำถัง' }} <span class="required-input">*</span></label>
                            <InputText id="iex_extinguisher_code" type="text" disabled v-model="iex_extinguisher_code" />
                            <!-- v-model="iex_extinguisher_code" -->
                        </div>

                        <div class="p-field p-col-12 p-lg-3 p-mt-2">
                            <label for="ira_location_name">{{ 'ประเภทถังดับเพลิง' }} <span class="required-input">*</span></label>
                            <!-- <InputText
                                id="iex_extinguisher_type"
                                type="text"
                                v-model="iex_extinguisher_type"
                                required="true"
                                :class="{
                                    'p-invalid': error_iex_extinguisher_type && !iex_extinguisher_type
                                }"
                                @input="acceptNumberPhone"
                                ref="TextBox_1"
                                @keyup.left="moveFocus($event, 'TextBox_12', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_2', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_4', 'Input')"
                            /> -->
                            <Dropdown
                                id="iex_extinguisher_type"
                                v-model="iex_extinguisher_type"
                                :options="FireExtinguisherOptions_AT_extinguisher_notAll"
                                optionLabel="fs_tname"
                                required="true"
                                :filter="true"
                                :disabled="chackDisableType()"
                                @change="genCodeId"
                                :placeholder="$t('placeholderSelectBox')"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="FireExtinguisherOptions_AT_extinguisher_notAll">
                                    <div v-if="FireExtinguisherOptions_AT_extinguisher_notAll.value">
                                        <div>{{ FireExtinguisherOptions_AT_extinguisher_notAll.value }}</div>
                                    </div>
                                </template>
                                <template #option="FireExtinguisherOptions_AT_extinguisher_notAll">
                                    <div>{{ FireExtinguisherOptions_AT_extinguisher_notAll.option }}</div>
                                </template>
                            </Dropdown>
                            <small class="p-invalid" v-if="error_iex_extinguisher_type && !iex_extinguisher_type">{{
                                'กรุณาระบุประเภทถังดับเพลิง'
                            }}</small>
                        </div>

                        <div class="p-field p-col-12 p-lg-6 p-mt-5">
                            <span hidden>{{ url }}</span>
                            <div class="p-grid">
                                <div class="p-col-8 p-lg-8">
                                    <Button
                                        @click="onFileChange"
                                        style="margin-top: 12px"
                                        class="p-button-success"
                                        icon="pi pi-plus"
                                        label="เลือกไฟล์ภาพ"
                                        ref="TextBox_2"
                                        @keyup.left="moveFocus($event, 'TextBox_1', 'Input')"
                                        @keyup.right="moveFocus($event, 'TextBox_3', 'Button')"
                                        @keyup.down="moveFocus($event, 'TextBox_5', 'Input')"
                                    >
                                    </Button>
                                    <input
                                        style="visibility: hidden; display: none; text-overflow: ellipsis"
                                        type="file"
                                        id="fireHydrant_uploadImageFile"
                                        @change="onFileChange"
                                        class="inputzone"
                                        accept="image/*"
                                    />
                                </div>
                                <div class="p-col-4 p-lg-4">
                                    <Button
                                        @click="clearImage()"
                                        icon="pi pi-times"
                                        class="p-button-danger"
                                        style="width: auto; margin-top: 4.5px"
                                        :label="$t('clearImage')"
                                        ref="TextBox_3"
                                        @keyup.left="moveFocus($event, 'TextBox_2', 'Button')"
                                        @keyup.right="moveFocus($event, 'TextBox_4', 'Input')"
                                        @keyup.down="moveFocus($event, 'TextBox_6', 'Input')"
                                    />
                                </div>
                            </div>

                            <div id="preview">
                                <img v-if="resolveImageSrc(url)" :src="resolveImageSrc(url)" />
                            </div>
                            <div id="io_image" ref="io_image" hidden></div>
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-mt-2 p-mb-2" style="display: flex">
                        <div class="p-field p-col-12 p-lg-3">
                            <label for="iex_place_name">{{ $t('iex_place_name') }} <span class="required-input">*</span></label>
                            <InputText
                                id="iex_place_name"
                                type="text"
                                v-model="iex_place_name"
                                autofocus
                                required="true"
                                :class="{
                                    'p-invalid': error_iex_place_name && !iex_place_name
                                }"
                                ref="TextBox_1"
                                @keyup.left="moveFocus($event, 'TextBox_20', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_2', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_7', 'Input')"
                            />
                            <!-- @keyup.right="moveFocus($event, 'TextBox_2','InputNumber')" -->
                            <small class="p-invalid" v-if="error_iex_place_name && !iex_place_name">{{ $t('iex_place_name_validate') }}</small>
                        </div>

                        <div class="p-field p-col-12 p-lg-3">
                            <label for="location_type">{{ $t('iex_location_type') }} </label>
                            <InputText
                                id="iex_location_type"
                                type="text"
                                v-model="iex_location_type"
                                ref="TextBox_4"
                                @keyup.left="moveFocus($event, 'TextBox_20', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_2', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_7', 'Input')"
                            />
                        </div>
                        <!--  -->

                        <!-- / -->

                        <div class="p-field p-col-12 p-lg-1 p-mt-1">
                            <label for="iex_latch_lock">{{ 'สลักล็อก' }}</label>
                            <Dropdown
                                v-model="iex_latch_lock"
                                @change="calStatus"
                                optionLabel="name"
                                :options="trueOrFalse"
                                :placeholder="$t('placeholderSelectBox')"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="trueOrFalse">
                                    <div v-if="trueOrFalse.value">
                                        <div>{{ trueOrFalse.value.name }}</div>
                                    </div>
                                    <span v-else>
                                        {{ trueOrFalse.placeholder }}
                                    </span>
                                </template>
                                <template #option="trueOrFalse">
                                    <div>{{ trueOrFalse.option.name }}</div>
                                </template>
                            </Dropdown>
                        </div>

                        <div class="p-field p-col-12 p-lg-1 p-mt-1">
                            <label for="iex_controller">{{ 'คันบังคับ' }}</label>
                            <Dropdown
                                v-model="iex_controller"
                                @change="calStatus"
                                optionLabel="name"
                                :options="trueOrFalse"
                                :placeholder="$t('placeholderSelectBox')"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="trueOrFalse">
                                    <div v-if="trueOrFalse.value">
                                        <div>{{ trueOrFalse.value.name }}</div>
                                    </div>
                                    <span v-else>
                                        {{ trueOrFalse.placeholder }}
                                    </span>
                                </template>
                                <template #option="trueOrFalse">
                                    <div>{{ trueOrFalse.option.name }}</div>
                                </template>
                            </Dropdown>
                        </div>

                        <div class="p-field p-col-12 p-lg-1 p-mt-1">
                            <label for="iex_pressure_gauge">{{ 'เกจความดัน' }}</label>
                            <Dropdown
                                v-model="iex_pressure_gauge"
                                @change="calStatus"
                                optionLabel="name"
                                :options="trueOrFalse"
                                :placeholder="$t('placeholderSelectBox')"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="trueOrFalse">
                                    <div v-if="trueOrFalse.value">
                                        <div>{{ trueOrFalse.value.name }}</div>
                                    </div>
                                    <span v-else>
                                        {{ trueOrFalse.placeholder }}
                                    </span>
                                </template>
                                <template #option="trueOrFalse">
                                    <div>{{ trueOrFalse.option.name }}</div>
                                </template>
                            </Dropdown>
                        </div>

                        <div class="p-field p-col-12 p-lg-1 p-mt-1">
                            <label for="iex_line_spray">{{ 'สายฉีด' }}</label>
                            <Dropdown
                                v-model="iex_line_spray"
                                @change="calStatus"
                                optionLabel="name"
                                :options="trueOrFalse"
                                :placeholder="$t('placeholderSelectBox')"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="trueOrFalse">
                                    <div v-if="trueOrFalse.value">
                                        <div>{{ trueOrFalse.value.name }}</div>
                                    </div>
                                    <span v-else>
                                        {{ trueOrFalse.placeholder }}
                                    </span>
                                </template>
                                <template #option="trueOrFalse">
                                    <div>{{ trueOrFalse.option.name }}</div>
                                </template>
                            </Dropdown>
                        </div>

                        <div class="p-field p-col-12 p-lg-1 p-mt-1">
                            <label for="iex_chassis">{{ 'ตัวถัง' }}</label>
                            <Dropdown
                                v-model="iex_chassis"
                                optionLabel="name"
                                @change="calStatus"
                                :options="trueOrFalse"
                                :placeholder="$t('placeholderSelectBox')"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="trueOrFalse">
                                    <div v-if="trueOrFalse.value">
                                        <div>{{ trueOrFalse.value.name }}</div>
                                    </div>
                                    <span v-else>
                                        {{ trueOrFalse.placeholder }}
                                    </span>
                                </template>
                                <template #option="trueOrFalse">
                                    <div>{{ trueOrFalse.option.name }}</div>
                                </template>
                            </Dropdown>
                        </div>

                        <div class="p-field p-col-12 p-lg-1 p-mt-1">
                            <label for="location_type">{{ 'สถานะ' }}</label>
                            <InputText
                                type="text"
                                v-model="this.statusOrganize"
                                disabled
                                style="cursor: default; opacity: 1"
                                :style="{ color: this.statusOrganize === 'ชำรุด' ? 'red' : 'inherit' }"
                            />
                        </div>
                    </div>
                    <!-- </div> -->

                    <!-- Doe เพิ่มหมุด map V.2 1/9  @input="inputMap_PAT_latlon" -->
                    <div class="p-formgrid p-grid">
                        <div class="p-field p-col-12 p-lg-3 p-mt-2">
                            <label for="provinceOptions">{{ $t('province') }} <span class="required-input">*</span></label>
                            <Dropdown
                                v-model="ifh_selectedProvince"
                                @input="inputMap_PAT_latlon"
                                :options="provinceOptions"
                                @change="someHandler('ch-province')"
                                optionLabel="province_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                                :class="{
                                    'p-invalid': error_ifh_selectedProvince && !ifh_selectedProvince
                                }"
                            >
                                <template #value="provinceOptions">
                                    <div v-if="provinceOptions.value">
                                        <div>{{ provinceOptions.value.province_name }}</div>
                                    </div>
                                </template>
                                <template #option="provinceOptions">
                                    <div>{{ provinceOptions.option.province_name }}</div>
                                </template>
                            </Dropdown>
                            <small class="p-invalid" v-if="error_ifh_selectedProvince && !ifh_selectedProvince">{{ 'กรุณาระบุ จังหวัด' }}</small>
                        </div>

                        <div class="p-field p-col-12 p-lg-3 p-mt-2">
                            <label for="amphurOptions">{{ $t('amphur') }} <span class="required-input">*</span></label>
                            <Dropdown
                                :disabled="ira_isDisabledAmphur == 1"
                                v-model="ira_selectedAmphur"
                                @input="inputMap_PAT_latlon"
                                @change="someHandler('ch-amphur')"
                                :options="amphurOptions"
                                optionLabel="amphur_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                                :class="{
                                    'p-invalid': error_ira_selectedAmphur && !ira_selectedAmphur
                                }"
                            >
                                <template #value="amphurOptions">
                                    <div v-if="amphurOptions.value">
                                        <div>{{ amphurOptions.value.amphur_name }}</div>
                                    </div>
                                </template>
                                <template #option="amphurOptions">
                                    <div>{{ amphurOptions.option.amphur_name }}</div>
                                </template>
                            </Dropdown>
                            <small class="p-invalid" v-if="error_ira_selectedAmphur && !ira_selectedAmphur">{{ 'กรุณาระบุ เขต/อำเภอ' }}</small>
                        </div>

                        <div class="p-field p-col-12 p-lg-2 p-mt-2">
                            <label for="tambonOptions">{{ $t('tambon') }} <span class="required-input">*</span></label>
                            <Dropdown
                                :disabled="ira_isDisabledTambon == 1"
                                v-model="ira_selectedTambon"
                                @input="inputMap_PAT_latlon"
                                :options="tambonOptions"
                                optionLabel="tambon_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                                :class="{
                                    'p-invalid': error_ira_selectedTambon && !ira_selectedTambon
                                }"
                            >
                                <template #value="tambonOptions">
                                    <div v-if="tambonOptions.value">
                                        <div>{{ tambonOptions.value.tambon_name }}</div>
                                    </div>
                                </template>
                                <template #option="tambonOptions">
                                    <div>{{ tambonOptions.option.tambon_name }}</div>
                                </template>
                            </Dropdown>
                            <small class="p-invalid" v-if="error_ira_selectedTambon && !ira_selectedTambon">{{ 'กรุณาระบุ แขวง/ตำบล' }}</small>
                        </div>

                        <!-- Doe เพิ่ม สถานีดับเพลิงและกู้ภัย -->
                        <!-- <div class="p-field p-col-12 p-lg-3 p-mt-2 " 
              v-if="!ifh_selectedProvince &&
                     !ira_selectedAmphur &&
                     !ira_selectedTambon">
                <label for="FireStationOptions">{{ $t("ira_FireStation") }}</label>
                <span class="required-input"> *</span>
                <Dropdown
                  
                  v-model="ifh_FireStationSelected"
                  :options="FireStationOptions"
                  optionLabel="fs_tname"
                  :filter="true"
                  :placeholder="$t('placeholderSelectBox')"
                  :showClear="true"
                  :class="{
                    'p-invalid': error_ifh_FireStationSelected && !ifh_FireStationSelected
                  }"
                  :clearFilterDropdown="dropdownClearFilerValue"
                >
                  <template #value="FireStationOptions">
                    <div v-if="FireStationOptions.value">
                      <div>{{ FireStationOptions.value.fs_tname }}</div>
                    </div>
                  </template>
                  <template #option="FireStationOptions">
                    <div class=".EV_disasterOptions">{{ FireStationOptions.option.fs_tname }}</div>
                  </template>
                </Dropdown>
                <small
                  class="p-invalid"
                  v-if="error_ifh_FireStationSelected && !ifh_FireStationSelected"
                  >{{ 'กรุณาระบุ สถานีดับเพลิงและกู้ภัย' }}</small
                >
              </div> -->

                        <!-- <div class="p-field p-col-12 p-lg-3 p-mt-2 " v-else> -->
                        <div class="p-field p-col-12 p-lg-2 p-mt-2">
                            <label for="FireStationOptions">{{ $t('ira_FireStation') }} <span class="required-input">*</span></label>
                            <Dropdown
                                v-model="ifh_FireStationSelected"
                                :options="FireStationOptions_Form"
                                optionLabel="fs_tname"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <!-- @input="inputMap_PAT_latlon" -->
                                <template #value="{ value }">
                                    <div v-if="value">
                                        <div>{{ value.fs_tname }}</div>
                                    </div>
                                </template>
                                <template #option="{ option }">
                                    <div>{{ option.fs_tname }}</div>
                                </template>
                            </Dropdown>
                            <!--<small class="p-invalid" v-if="error_ifh_FireStationSelected && !ifh_FireStationSelected">{{
                                'กรุณาระบุ สถานีดับเพลิงและกู้ภัย'
                            }}</small> 
                            :class="{
                                    'p-invalid': error_ifh_FireStationSelected && !ifh_FireStationSelected
                                }"-->
                        </div>

                        <div class="p-field p-col-12 p-lg-2 p-mt-2">
                            <label for="FireStationOptions">{{ $t('ira_DistrictOffice') }}</label>
                            <span class="required-input"> *</span>
                            <Dropdown
                                v-model="organizeTypeOptions"
                                :options="organizeTypeOptions_Form"
                                optionLabel="system_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :class="{
                                    'p-invalid': error_organizeTypeOptions && !organizeTypeOptions
                                }"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <!-- @input="inputMap_PAT_latlon" -->
                                <template #value="{ value }">
                                    <div v-if="value">
                                        <div>{{ value.system_name }}</div>
                                    </div>
                                </template>
                                <template #option="{ option }">
                                    <div>{{ option.system_name }}</div>
                                </template>
                            </Dropdown>
                            <small class="p-invalid" v-if="error_organizeTypeOptions && !organizeTypeOptions">{{ 'กรุณาระบุ สำนักงานเขต' }}</small>
                        </div>
                    </div>
                    <!-- Doe เพิ่มหมุด map V.2 1/9  @input="inputMap_PAT_latlon" จบ-->
                    <!-- <div class="p-formgrid p-grid p-mt-3">
          <div class="p-field p-col-12 p-lg-12 p-mt-2">
            <label for="ifh_location">{{ 'ที่ตั้ง' }}<span class="required-input"></span></label>
            <InputText
              id="ifh_location"
              type="text"
              v-model="ifh_location"
              required="true"
              ref="TextBox_7"
              @keyup.left="moveFocus($event, 'TextBox_6','Input')"
              @keyup.right="moveFocus($event, 'TextBox_8','Input')"
              @keyup.up="moveFocus($event, 'TextBox_4','Input')"
              @keyup.down="moveFocus($event, 'TextBox_8','Input')"
              />
          </div>
        </div> -->

                    <div class="p-formgrid p-grid p-mt-3">
                        <div class="p-field p-col-12 p-lg-2 p-mt-2">
                            <label for="community_select">{{ $t('ชุมชน') }}</label>
                            <Dropdown
                                v-model="ifh_community_name"
                                :options="communityOptions"
                                optionLabel="community_name"
                                :dataKey="'community_id'"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="slotProps">
                                    <div v-if="slotProps.value">
                                        <div>{{ slotProps.value.community_name }}</div>
                                    </div>
                                    <span v-else>
                                        {{ slotProps.placeholder }}
                                    </span>
                                </template>

                                <template #option="slotProps">
                                    <div class="communityOptions">
                                        {{ slotProps.option.community_name }}
                                    </div>
                                </template>
                            </Dropdown>
                        </div>

                        <div class="p-field p-col-12 p-lg-2 p-mt-2">
                            <label for="iex_details"
                                >{{ 'รายละเอียด' }}
                                <span class="required-input"></span>
                            </label>
                            <InputText
                                id="iex_details"
                                type="text"
                                v-model="iex_details"
                                required="true"
                                ref="TextBox_8"
                                @keyup.left="moveFocus($event, 'TextBox_7', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_9', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_7', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_9', 'Input')"
                            />
                        </div>

                        <div class="p-field p-col-12 p-lg-2 p-mt-2">
                            <label for="date_expire_form">วันหมดอายุ <span class="required-input"> </span></label>
                            <InputText id="date_expire_form" type="date" v-model="date_expire_form" autofocus />
                        </div>
                        <div class="p-field p-col-12 p-lg-2 p-mt-2">
                            <label for="date_expire_form">สถานะการตรวจสอบ <span class="required-input"> </span></label>
                            <Dropdown
                                id="iex_extinguisher_status"
                                v-model="iex_extinguisher_status"
                                :options="status_option"
                                required="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="status_option">
                                    <div v-if="status_option.value">
                                        <div>{{ status_option.value }}</div>
                                    </div>
                                </template>
                                <template #option="status_option">
                                    <div>{{ status_option.option }}</div>
                                </template>
                            </Dropdown>
                            <!-- <small class="p-invalid" v-if="error_iex_extinguisher_status && !iex_extinguisher_status">{{
                                'กรุณาระบุประเภทถังดับเพลิง'
                            }}</small> -->
                        </div>
                        <div class="p-field p-col-12 p-lg-2 p-mt-2">
                            <label for="date_create_form">วันที่สร้างข้อมูล <span class="required-input"> </span></label>
                            <InputText id="date_create_form" type="text" v-model="date_create_form" autofocus disabled />
                        </div>
                        <div class="p-field p-col-12 p-lg-2 p-mt-2">
                            <label for="date_update_form">{{ $t('imp_update_info_date') }}<span class="required-input"> </span></label>
                            <InputText id="date_update_form" type="text" v-model="date_update_form" autofocus disabled />
                        </div>
                    </div>

                    <!-- Doe เพิ่มหมุด map V.2 2/9  @input="inputMap_latlon" -->
                    <div class="p-formgrid p-grid p-mt-3">
                        <div class="p-field p-col-12 p-lg-4">
                            <label for="ifh_lat">{{ $t('lat') }}<span class="required-input"> *</span></label>
                            <InputText
                                id="ifh_lat"
                                type="text"
                                v-model="ifh_lat"
                                :placeholder="!ifh_lat ? '-' : ''"
                                @input="handleInput"
                                :class="{
                                    'p-invalid': (error_ifh_lat && !ifh_lat) || error_ifh_lat_dot
                                }"
                                ref="TextBox_9"
                                @keyup.left="moveFocus($event, 'TextBox_9', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_10', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_8', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_12', 'Button')"
                            />
                            <small class="p-invalid" v-if="error_ifh_lat && !ifh_lat">{{ 'กรุณาระบุ ค่าละติจูด' }}</small>
                            <small class="p-invalid" v-if="error_ifh_lat_dot">{{ 'ค่าละติจูด ต้องเป็น 13.XXXXXX' }}</small>
                        </div>
                        <div class="p-field p-col-12 p-lg-4">
                            <label for="ifh_lon">{{ $t('lon') }}<span class="required-input"> *</span></label>
                            <InputText
                                id="ifh_lon"
                                type="text"
                                v-model="ifh_lon"
                                :placeholder="!ifh_lon ? '-' : ''"
                                @input="handleInput"
                                :class="{
                                    'p-invalid': error_ifh_lon && !ifh_lon
                                }"
                                ref="TextBox_10"
                                @keyup.left="moveFocus($event, 'TextBox_9', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_11', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_8', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_12', 'Button')"
                                pattern="^\\d{3}(\\.\\d{6})?$"
                            />
                            <small class="p-invalid" v-if="error_ifh_lon && !ifh_lon">{{ 'กรุณาระบุ ค่าลองจิจูด' }}</small>
                            <small class="p-invalid" v-if="error_ifh_lon_dot">{{ 'ค่าลองจิจูด ต้องเป็น 100.XXXXXX' }}</small>
                        </div>
                        <!-- Doe เพิ่มหมุด map V.2 2/9  @input="inputMap_latlon" จบ-->

                        <!-- Doe:  เพิ่ม มุดmap 1/4 -->
                        <div class="p-field p-col-12 p-lg-4 p-mt-5">
                            <Button
                                @click="
                                    displayMap = true;
                                    sendM(ifh_lat, ifh_lon);
                                    sendM_PAT(ira_selectedTambon, ira_selectedAmphur, ifh_selectedProvince, ifh_FireStationSelected);
                                "
                                icon="pi pi-map-marker"
                                :label="$t('openMapBtn')"
                                class="p-button-secondary"
                                ref="TextBox_11"
                                @keyup.left="moveFocus($event, 'TextBox_10', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_12', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_8', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_12', 'Button')"
                            />
                        </div>
                        <!-- Doe:  เพิ่ม มุดmap 1/4 จบ-->

                        <div v-if="locationLoading" class="p-mt-2">
                            <small class="p-text-info"><i class="pi pi-spin pi-spinner"></i> กำลังโหลดข้อมูลพิกัด...</small>
                        </div>
                    </div>

                    <!-- Doe เพิ่มหมุด map V.2 3/9  -->
                    <small class="warningLATLON" v-if="this.error_latlon_P || this.error_latlon_A || this.error_latlon_T || error_latlon_country"
                        >ข้อควรระวัง : ข้อมูลพิกัดที่คุณเลือกไม่สามารถระบุ
                        <span v-if="this.error_latlon_P || error_latlon_country"> จังหวัด </span>
                        <span v-if="this.error_latlon_A || error_latlon_country"> เขต/อำเภอ </span>
                        <span v-if="this.error_latlon_T || error_latlon_country"> แขวง/ตำบล </span>
                        <span> ได้ </span>
                    </small>
                    <!-- Doe เพิ่มหมุด map V.2 3/9  จบ-->
                </div>
            </div>
            <template #footer>
                <!-- โหลดเพิ่มแก้ไข 2/8-->
                <Button
                    v-if="selectedData != ''"
                    :label="$t('cancelBtn')"
                    icon="pi pi-times"
                    :disabled="loadingCreate ? true : false"
                    class="p-button-text"
                    @click="clearData()"
                    ref="TextBox_12"
                    @keyup.left="moveFocus($event, 'TextBox_11', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_13', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_11', 'Input')"
                />
                <Button
                    v-else
                    :label="$t('clearBtn')"
                    icon="pi pi-times"
                    :disabled="loadingCreate ? true : false"
                    class="p-button-text"
                    @click="clearData()"
                    ref="TextBox_12"
                    @keyup.left="moveFocus($event, 'TextBox_11', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_13', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_11', 'Input')"
                />
                <Button
                    :label="$t('saveBtn')"
                    icon="pi pi-check"
                    :disabled="loadingCreate ? true : false"
                    class="p-button-text"
                    @click="saveData()"
                    ref="TextBox_13"
                    @keyup.left="moveFocus($event, 'TextBox_12', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_1', 'Input')"
                    @keyup.up="moveFocus($event, 'TextBox_11', 'Input')"
                />
                <!-- โหลดเพิ่มแก้ไข 2/8 จบ-->
            </template>
        </Dialog>

        <Dialog :modal="true" :header="$t('ConfirmDelete')" :visible.sync="displayConfirmation" :style="{ width: '350px' }">
            <div class="confirmation-content p-mt-3">
                <i class="pi pi-exclamation-triangle p-mr-3 p-mt2" style="font-size: 2rem" />
                <span>{{ $t('ConfirmDeleteSub') }}</span>
            </div>
            <template #footer>
                <Button :label="$t('cancelBtn')" icon="pi pi-times" @click="displayConfirmation = false" class="p-button-text" />
                <Button :label="$t('confirmBtn')" icon="pi pi-check" @click="confirmDelete(temp)" class="p-button-text" autofocus />
            </template>
        </Dialog>

        <Dialog :modal="true" :header="$t('map')" :visible.sync="displayMap" :style="{ width: '700px' }">
            <div class="confirmation-content p-mt-3" style="padding-bottom: 20px; position: relative">
                <!-- Doe : เพิ่ม มุดmap 2/4 -->
                <!-- Doe เพิ่มหมุด map V.2 4/9  -->
                <map-area @selectMap="selectMap_passValue" :latlon="this.latlon" :PAT="this.PAT" :FSS="{}" @selectMap_PAT="receiveM_PAT"></map-area>

                <Button icon="pi pi-map-marker" class="btnNow" @click="setCurrentLocation"></Button>

                <!-- Doe เพิ่มหมุด map V.2 4/9  จบ-->
                <!-- Doe :  เพิ่ม มุดmap 2/4 -->
            </div>
            <Button :label="$t('saveBtn')" icon="pi pi-check" class="p-button-text" @click="selectMap_displayMap()" />
        </Dialog>

        <!-- Are you sure for close this modal -->
        <Dialog :modal="true" :header="$t('ConfirmCloseModal')" :visible.sync="displayConfirmationCloseModal" :style="{ width: '350px' }">
            <div class="confirmation-content p-mt-3">
                <span>{{ $t('ConfirmCloseModalSub') }}</span>
            </div>
            <template #footer>
                <Button :label="$t('cancelBtn')" icon="pi pi-times" @click="displayConfirmationCloseModal = false" class="p-button-text" />
                <Button :label="$t('confirmBtn')" icon="pi pi-check" @click="closeAllModal()" class="p-button-text" autofocus />
            </template>
        </Dialog>

        <!-- Image -->

        <Galleria
            :value="imgTable"
            containerStyle="max-width: 850px"
            :circular="true"
            :fullScreen="true"
            :showItemNavigators="false"
            :showThumbnails="false"
            :visible.sync="displayBasic2"
        >
            <template #item="slotProps">
                <img :src="imgTable" class="imgDia" alt="" />
            </template>
        </Galleria>

        <!-- Doe PDF เลือกได้  -->
        <Dialog header="ตั้งค่า " :visible.sync="displayEditPDF" :style="{ width: '25rem' }" :contentStyle="{ 'overflow-y': 'visible' }">
            <label>ตั้งค่าการแสดงข้อมูลตารางและการส่งออกข้อมูล</label>
            <div style="margin: 2.5rem 1rem 0 1rem">
                <div class="p-formgrid p-grid">
                    <div class="p-field p-col-12">
                        <MultiSelect
                            v-model="columnsSelectorDialog"
                            :options="columns"
                            optionLabel="title"
                            :placeholder="$t('placeholderSelectBox')"
                            :filter="true"
                            class="multiselect-custom"
                            :clearFilterMultiSelect="multiSelectClearFilerValue"
                        >
                            <template #value="slotProps">
                                <div class="item item-value" v-for="option of slotProps.value" :key="option.dataKey">
                                    <div>{{ option.title }}</div>
                                </div>
                                <template v-if="!slotProps.value || slotProps.value.length === 0">
                                    {{ $t('placeholderSelectBox') }}
                                </template>
                            </template>
                            <template #option="slotProps">
                                <div class="item">
                                    <div>{{ slotProps.option.title }}</div>
                                </div>
                            </template>
                        </MultiSelect>
                        <div style="margin-top: 1rem; display: flex; justify-content: flex-end">
                            <Button
                                @click="
                                    ClearEditPDF();
                                    multiSelectClearFilerValue += 1;
                                "
                                class="p-button-clear"
                                :label="'ล้างข้อมูล'"
                                style="margin-right: 1rem"
                            />
                            <Button @click="SelectAllEditPDF()" class="p-button-info" :label="'เลือกทั้งหมด'" />
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <div>
                    <Button @click="CloseEditPDF()" :label="'ยกเลิก'" icon="pi pi-times" class="p-button-text" />
                    <Button @click="SaveEditPDF()" :label="'บันทึก'" icon="pi pi-check" class="p-button-text" />
                </div>
            </template>
        </Dialog>
        <!-- Doe PDF เลือกได้ z-index: -10; -->
        <div id="qrCodeContainer" class="qr-container" style="z-index: -10; display: none; position: absolute; top: 0; left: 0">
            <img id="qrCodeImage" alt="QR Code" class="qr-code" />
            <div class="code-label">{{ code }}</div>
        </div>
    </div>
</template>

<script>
import mapArea from '../Map';
import EventBus from '../../../event-bus';

// Doe : PDF 2/3
// เพิ่ม pdf กับ font
// import { jsPDF } from "jspdf";
// import {font} from '../../../../public/assets/font/Sarabun-Regular-normal';
// Doe : PDF 2/3 จบ
import moment from 'moment';
import fnExtinguisher from './generateExtinguisher';
import GenerateExtinguisherModal from './GenerateExtinguisherModal';
import AssignOrganizationModal from './AssignOrganizationModal';
import QRCodeGenerator from './QRCodeGenerator';
import ExtinguisherDetails from './ExtinguisherDetails';

// import textFooter from '../../../mixins/textFooter_Search_html';
import QRCode from 'qrcode';

export default {
    name: 'initial-risk-area',
    components: {
        GenerateExtinguisherModal,
        AssignOrganizationModal,
        QRCodeGenerator,
        ExtinguisherDetails,
        mapArea
        // textFooter
        // QRCode
    },

    data() {
        return {
            isLoggedIn: false,
            isMobile: false,
            showGenerateModal: false,
            showAssignModal: false,
            showQrcodeModal: false,
            locationLoading: false,
            searchTimeout: null,
            searchInputRef: null,
            searchResults: [], // Store full search results
            currentPage: 1,
            isSearchMode: false,
            ifh_community_name: null,
            communityOptions: [],
            community_name: null,

            loading: false,

            lazyParams: {
                first: 0,
                rows: 50, // Default to match your current rows
                page: 1,
                totalRecords: 0
            },

            status_code: null,
            selectedFireHydrant: [],
            ife_extinguisher_code: '',
            iex_extinguisher_status_search: '',
            place_name: '',
            extinguisher_type: '',
            location_type: '',
            type: '',
            extinguisher_size: '',
            trueOrFalse: [
                { id: '1', name: 'TRUE' },
                { id: '2', name: 'FALSE' }
            ],
            multiSelectClearFilerValue: 0,
            date: moment().locale('th').add(543, 'year').format('l'),
            dropdownClearFilerValue: 0,
            // Doe ค้นหา  2/6
            filter: '',
            ms: false,
            cloneTable: [],
            // Doe ค้นหา  2/6 จบ

            // Doe โหลด โทรศัพท์
            // Doe width 1/4
            window: {
                width: 0,
                height: 0
            },
            end_date: null,
            start_date: null,
            checkRole: null,
            checkView_data: null,
            checkAdd_data: null,
            checkEdit_data: null,
            checkDelete_data: null,

            FireHydrant_Table: [],
            provinceOptions: [],
            selectedProvince: null,
            amphurOptions: [],
            selectedAmphur: null,
            isDisabledAmphur: 1,
            tambonOptions: [],
            selectedTambon: null,
            isDisabledTambon: 1,

            // Doe เพิ่ม สถานีดับเพลิงและกู้ภัย
            FireStationOptions: [],
            FireStationSelected: null,
            error_FireStation: false,
            FireStationOptions_AT: [],
            FireStationOptions_Form: [],
            organizeTypeOptions_Form: [],

            // ifh_FireStationOptions:[],
            ifh_FireStationSelected: null,
            organizeTypeOptions: null,
            error_ifh_FireStationSelected: false,
            error_organizeTypeOptions: false,
            error_iex_place_name: false,
            error_iex_extinguisher_type: false,
            // error_iex_extinguisher_status: false,
            // Doe ชุมชน

            error_ifh_community: false,

            ifh_soi_name: '',
            soi_name: '',

            pipe_size: '',
            road_name: '',
            iex_extinguisher_size: '',
            ifh_road_name: '',
            FireStation_sel: false,
            i: 0,

            ifh_location: '',

            // img
            url: null,
            imgTable: null,
            displayBasic2: false,
            filter_date_field: null,
            filters: {},
            temp: null,
            showOrganize: false,
            selectedOrganize: {},
            location_name: '',
            displayConfirmation: false,
            displayMap: false,

            disaster_table: [],
            disasterOptions: [],
            disasterSelect: null,

            riskLevelOptions: [],
            riskLevelSelected: null,

            header: this.$i18n.t('iex_modal_title_add'),
            selectedData: '',

            Dropdown_Fire_type: '',
            Dropdown_Fire_boundary: '',
            Dropdown_Fire_id: '',

            FireHydrantModal: false,
            ira_location_name: '',
            ira_location_detail: '',
            ira_selectedOrganize: {},
            ifh_selectedProvince: null,
            ira_selectedAmphur: null,
            ira_selectedTambon: null,
            ira_isDisabledAmphur: 1,
            ira_isDisabledTambon: 1,
            ira_disasterTypeSelected: null,
            ira_riskLevelSelected: null,
            ifh_lat: '',
            ifh_lon: '',
            imageName: '',

            error_ifh_selectedProvince: false,
            error_ira_selectedAmphur: false,
            error_ira_selectedTambon: false,
            error_ira_selectedOrganize: false,
            error_ira_location_name: false,
            error_ira_selectedDisaster: false,

            error_iex_extinguisher_size: false,
            error_ifh_road_name: false,
            error_ifh_status: false,
            error_ifh_lat: false,
            error_ifh_lat_dot: false,
            error_ifh_lon: false,
            error_ifh_lon_dot: false,

            check_duplicate: '',
            displayConfirmationCloseModal: false,
            tempFor_displayConfirmationCloseModal: '',

            status: null,
            status_Options_Search: ['เลือกทั้งหมด', 'ปกติ', 'ชำรุด', 'ระหว่างติดตั้ง'],
            status_Options: ['ปกติ', 'ชำรุด', 'ระหว่างติดตั้ง'],
            ifs_status: null,

            inspec_details: '',
            ifs_inspec_details: '',
            //  Doe เพิ่มหมุด map V.2 5/9  -->
            latlon: {},
            PAT: {},
            FSS: {},
            sP: [],
            sA: [],
            FireStationOptions_Form_main: [],
            error_latlon_country: false,
            error_latlon_land: false,
            error_latlon_P: false,
            error_latlon_A: false,
            error_latlon_T: false,
            iP: 0,
            iA: 0,

            //  Doe เพิ่มหมุด map V.2 5/9  จบ-->

            // โหลดเพิ่มแก้ไข 3/8
            loadingCreate: false,
            // โหลดเพิ่มแก้ไข 3/8 จบ

            //
            text_Footer: false,
            Clone_Data_text_Footer: [],
            Data_text_Footer: [
                {
                    DataName: 'ชื่อสถานที่',
                    textShow: ''
                },
                {
                    DataName: 'ประเภท',
                    textShow: ''
                },
                {
                    DataName: 'ขนาดถังดับเพลิง',
                    textShow: ''
                },
                {
                    DataName: 'ประเภทสถานที่',
                    textShow: ''
                },
                {
                    DataName: 'เขต/อำเภอ',
                    textShow: ''
                },
                {
                    DataName: 'แขวง/ตำบล',
                    textShow: ''
                },
                {
                    DataName: 'ละติจูด',
                    textShow: ''
                },
                {
                    DataName: 'ลองจิจูด',
                    textShow: ''
                },
                {
                    DataName: 'หน่วยงานที่รับผิดชอบ',
                    textShow: ''
                },
                {
                    DataName: 'รายละเอียดการตรวจสอบ',
                    textShow: ''
                }
            ],

            table_BOXmanege: window.innerWidth > 700 ? 'p-field p-col' : '',
            table_editBTN: window.innerWidth > 700 ? this.$i18n.t('editBtn') : '',
            table_deleteBTN: window.innerWidth > 700 ? this.$i18n.t('deleteBtn') : '',
            table_genQR: window.innerWidth > 700 ? this.$i18n.t('qrCodeBtn') : '',

            table_headerStyle: this.checkInnerWidth('15rem', 'Column'),
            table_bodyStyle: this.checkInnerWidth('15rem', 'Body'),

            date_create_form: '',
            date_update_form: '',
            date_expire_form: '',

            iex_extinguisher_code: '',

            FireExtinguisherOptions_AT_extinguisher: [
                'เลือกทั้งหมด',
                'ถังดับเพลิงชนิดโฟม (Foam Extinguishers)',
                'ถังดับเพลิงสูตรน้ำ (Low Pressure Water Mist)',
                'ถังดับเพลิงชนิดผงเคมีแห้ง (Dry Chemical)',
                'ถังดับเพลิงชนิดก๊าซคาร์บอนไดออกไซด์ ( CO2 )',
                'ถังดับเพลิงชนิดน้ำ (Water Extinguishers)'
            ],

            iex_extinguisher_status_search_options: ['เลือกทั้งหมด', 'ตรวจสอบแล้ว', 'ยังไม่ตรวจสอบ'],

            FireExtinguisherOptions_AT_extinguisher_notAll: [
                'ถังดับเพลิงชนิดโฟม (Foam Extinguishers)',
                'ถังดับเพลิงสูตรน้ำ (Low Pressure Water Mist)',
                'ถังดับเพลิงชนิดผงเคมีแห้ง (Dry Chemical)',
                'ถังดับเพลิงชนิดก๊าซคาร์บอนไดออกไซด์ ( CO2 )',
                'ถังดับเพลิงชนิดน้ำ (Water Extinguishers)'
            ],

            status_option: ['ตรวจสอบแล้ว', 'ยังไม่ตรวจสอบ'],

            // Doe PDF เลือกได้  2/5
            setPDF_Hor: 'l',
            setPosition_Hor: [802, 34, 802, 570],
            setPDF_Ver: 'p',
            setPosition_Ver: [570, 34, 575, 815],
            setPDF_Styles: 'grid',
            setnamePDF: 'ตารางข้อมูลถังดับเพลิง',
            setPDF_fillColor: [95, 154, 250],
            setPDF_Margin: { left: 10, right: 10 },

            PDF_minCellWidthVer: 45,
            PDF_FontHeaderVer: 11,
            PDF_FontBodyVer: 7,

            PDF_BodySizeSelect: {},
            // PDF_BodySize:{
            //                 index: {cellWidth: 21},
            //                 pipe_size: {cellWidth: 35},
            //                 soi_name:{cellWidth:40},
            //                 road_name:{cellWidth:40},
            //                 // inspec_details:{cellWidth:58},
            //                 fire_station:{cellWidth:53},
            //                 location:{cellWidth:50},
            //                 inspec_details:{cellWidth:40},
            //                 status:{cellWidth:28},
            //                 // event_lat:{cellWidth:35},
            //                 // event_lon:{cellWidth:35}
            //                 event_latPDF:{cellWidth:28},
            //                 event_lonPDF:{cellWidth:28},

            //                 date_update_ddmmyy:{cellWidth:50}
            // },
            PDF_BodySize: {
                index: { cellWidth: 28 },
                place_name: { cellWidth: 50 },
                type: { cellWidth: 36 },
                fire_extinguisher_size: { cellWidth: 37 },
                // location_type:{cellWidth:36},
                // country:{cellWidth:36},
                // subdistrict:{cellWidth:36},
                lat: { cellWidth: 36 },
                lon: { cellWidth: 36 },
                // fire_station:{cellWidth:36},

                details: { cellWidth: 50 },
                date_created: { cellWidth: 38 },
                date_update: { cellWidth: 40 }
            },

            PDF_minCellWidthHor: 50,
            PDF_FontHeaderHor: 10,
            PDF_FontBodyHor: 8,

            PDF_BodySizeHorSelect: {},
            PDF_BodySizeHor: {
                // index: {cellWidth: 30},
                // pipe_size: {cellWidth: 40},
                // // soi_name:{cellWidth:50},
                // // road_name:{cellWidth:50},
                // // community_name:{cellWidth:50},
                // inspec_details:{cellWidth:52},
                // // event_lat:{cellWidth:40},
                // status:{cellWidth:40},
                // event_latPDF:{cellWidth:40},
                // event_lonPDF:{cellWidth:40},
                // date_create_ddmmyy:{cellWidth:55}
            },
            columns: [
                { title: 'ลำดับ', dataKey: 'index' },
                { title: 'ชื่อสถานที่', dataKey: 'place_name' },
                { title: 'ประเภท', dataKey: 'type' },
                { title: 'ขนาดถังดับเพลิง', dataKey: 'fire_extinguisher_size' },
                { title: 'ประเภทสถานที่', dataKey: 'location_type' },
                { title: 'เขต/อำเภอ', dataKey: 'country' },
                { title: 'แขวง/ตำบล', dataKey: 'subdistrict' },
                { title: 'ละติจูด', dataKey: 'lat' },
                { title: 'ลองจิจูด', dataKey: 'lon' },
                { title: 'หน่วยงานรับผิดชอบ', dataKey: 'fire_station' },
                { title: 'รายละเอียดการตรวจสอบ', dataKey: 'details' },
                { title: 'วันที่สร้างข้อมูล', dataKey: 'date_created' },
                { title: 'วันที่ปรับปรุงข้อมูล', dataKey: 'date_update' },
                { title: 'ผู้สร้างข้อมูล', dataKey: 'create_by_fullname' },
                { title: 'ผู้แก้ไขข้อมูล', dataKey: 'edit_by_fullname' }
            ],

            columnsSelector: null,
            columnsSelectorDialog: null,

            displayEditPDF: false,
            iex_place_name: '',
            iex_type: '',
            iex_location_type: '',
            iex_extinguisher_type: '',
            iex_extinguisher_status: '',
            iex_latch_lock: { id: '1', name: 'TRUE' },
            iex_controller: { id: '1', name: 'TRUE' },
            iex_pressure_gauge: { id: '1', name: 'TRUE' },
            iex_line_spray: { id: '1', name: 'TRUE' },
            iex_chassis: { id: '1', name: 'TRUE' },
            iex_details: '',
            columns_index: true,
            columns_img: true,
            columns_img_cloud: true,
            columns_genqr: true,
            columns_place_name: true,
            columns_code: true,
            columns_type: true,
            columns_status: true,
            columns_status_organize: true,
            columns_location_type: true,
            columns_amphur: true,
            columns_tambon: true,
            columns_community_name: true,
            columns_lat: true,
            columns_lon: true,
            columns_details: true,
            columns_date_expire: true,
            columns_date_created: true,
            columns_date_update: true,
            columns_create_by_fullname: true,
            columns_edit_by_fullname: true,
            columns_update_by: true,
            columns_fire_station: true,
            columns_extinguisher_size: true,
            GetData_ColumnsSearch: [],
            columns_disabled: true,

            statusOrganize: 'ปกติ',

            paramsQuery: '',
            code: '',

            items: [
                {
                    label: 'แนวตั้ง',
                    command: async () => {
                        try {
                            await this.searchAllFireHydrant();
                            this.$toast.add({ severity: 'success', summary: 'PDF', detail: 'แนวตั้ง', life: 3000 });

                            let columns = this.columnsSelector;
                            columns = columns.filter(function (item) {
                                return item.dataKey != 'image';
                            });

                            const Body_setCenter = [
                                'index',
                                'tambon_name',
                                'amphur_name',
                                'province_name',
                                'event_latPDF',
                                'event_lonPDF',
                                'status',
                                'pipe_size'
                            ];

                            const PintPDF = {
                                streak: this.setPDF_Ver,
                                setPosition: this.setPosition_Ver,
                                PDF_Styles: this.setPDF_Styles,
                                data: this.$refs.dt.processedData,
                                columns: columns,
                                columnsStyles: this.PDF_BodySizeSelect,
                                FileName: this.setnamePDF,
                                checkBody_Center: true,
                                Body_Center: Body_setCenter,
                                Col_FontSize: this.PDF_FontHeaderVer,
                                Body_FontSize: this.PDF_FontBodyVer,
                                minCell: this.PDF_minCellWidthVer,
                                marginPDF: this.setPDF_Margin,
                                fillColorPDF: this.setPDF_fillColor
                            };
                            this.printPDF(PintPDF);
                        } catch (error) {
                            this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Failed to generate PDF', life: 3000 });
                            console.error('Error generating PDF:', error);
                        }
                    }
                },
                {
                    label: 'แนวนอน',
                    command: async () => {
                        try {
                            await this.searchAllFireHydrant();
                            this.$toast.add({ severity: 'success', summary: 'PDF', detail: 'แนวนอน', life: 3000 });

                            let columns = this.columnsSelector;
                            columns = columns.filter(function (item) {
                                return item.dataKey != 'image';
                            });

                            const Body_setCenter = [
                                'index',
                                'tambon_name',
                                'amphur_name',
                                'province_name',
                                'event_latPDF',
                                'event_lonPDF',
                                'status',
                                'pipe_size'
                            ];

                            const PintPDF = {
                                streak: this.setPDF_Hor,
                                setPosition: this.setPosition_Hor,
                                PDF_Styles: this.setPDF_Styles,
                                data: this.$refs.dt.processedData,
                                columns: columns,
                                columnsStyles: this.PDF_BodySizeHorSelect,
                                FileName: this.setnamePDF,
                                checkBody_Center: true,
                                Body_Center: Body_setCenter,
                                Col_FontSize: this.PDF_FontHeaderHor,
                                Body_FontSize: this.PDF_FontBodyHor,
                                minCell: this.PDF_minCellWidthHor,
                                marginPDF: this.setPDF_Margin,
                                fillColorPDF: this.setPDF_fillColor
                            };
                            this.printPDF(PintPDF);
                        } catch (error) {
                            this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Failed to generate PDF', life: 3000 });
                            console.error('Error generating PDF:', error);
                        }
                    }
                }
            ]
        };
    },
    watch: {
        filter(newVal) {
            if (!newVal?.trim()) {
                this.isSearchMode = false;
            }
        },

        async FireHydrantModal(val) {
            if (val) {
                // When opening modal
                try {
                    // Load initial province options
                    const provinceResponse = await this.axios.post(`${this.$url_service}/general/country`, {
                        body: { topic: 'get-province' }
                    });
                    this.provinceOptions = provinceResponse.data.data;

                    // Load fire station options
                    const fsResponse = await this.axios.post(`${this.$url_service}/initial/firestation`, {
                        body: {
                            topic: 'get-option-firestation',
                            userData: this.getUser()
                        }
                    });
                    this.FireStationOptions = fsResponse.data.data;

                    // Set creation date for new entries
                    if (this.temp === null) {
                        const today = new Date();
                        this.date_create_form = today.toLocaleDateString('th-TH', {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric'
                        });
                        this.date_update_form = this.date_create_form;

                        let date = new Date();
                        date.setFullYear(date.getFullYear() + 5);
                        this.date_expire_form = date.toISOString().substring(0, 10);

                        //set lat lon with user location in cookie

                        // const userLat = this.getCookie('userLatitude');
                        // const userLon = this.getCookie('userLongitude');
                        // if (userLat && userLon) {
                        //     this.ifh_lat = userLat;
                        //     this.ifh_lon = userLon;
                        // } else {
                        //     this.ifh_lat = '0.0';
                        //     this.ifh_lon = '0.0';
                        // }

                        // this.ifh_lat = this.ifh_lat || '0.0';
                        // this.ifh_lon = this.ifh_lon || '0.0';
                    } else {
                        // Set update date for existing entries
                        this.date_update_form = moment(this.temp.date_update).locale('th').add(543, 'year').format('l');
                    }

                    // Check fire form search only if no selected data
                    if (!this.selectedData) {
                        await this.check_Fire_Form_search(this.ira_selectedTambon, this.ira_selectedAmphur, this.ifh_selectedProvince, 'form', false);
                    }
                } catch (error) {
                    console.error('Error initializing modal:', error);
                }
            } else {
                // When closing modal
                if (
                    this.tempFor_displayConfirmationCloseModal == '' &&
                    this.selectedData == '' &&
                    this.iex_extinguisher_size != null &&
                    this.iex_extinguisher_size != '' &&
                    this.ifs_status != '' &&
                    this.ifh_lat != '' &&
                    this.ifh_lon != '' &&
                    this.ifh_FireStationSelected != null &&
                    this.ifh_FireStationSelected != 'null' &&
                    this.organizeTypeOptions != null &&
                    this.organizeTypeOptions != 'null' &&
                    this.ifh_location != ''
                ) {
                    // Show confirmation dialog
                    try {
                        const result = await this.$fire({
                            title: 'ยืนยันการปิดหน้าต่างจัดการข้อมูล',
                            text: 'คุณต้องการออกจากการจัดการข้อมูลใช่หรือไม่ ?',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'ตกลง',
                            cancelButtonText: 'ยกเลิก'
                        });

                        if (result.value) {
                            this.FireHydrantModal = false;
                            this.clearData();
                        } else {
                            this.FireHydrantModal = true;
                        }
                    } catch (error) {
                        console.error('Error showing confirmation dialog:', error);
                    }
                } else {
                    this.clearData();
                }
            }
        },

        displayConfirmationCloseModal(val) {
            if (val == true) {
                this.FireHydrantModal = true;
            }
        },

        async selectedData(val) {
            if (!val) return;

            try {
                if (val.location_id === 'null') {
                    this.ifh_selectedProvince = null;
                    this.ira_selectedAmphur = null;
                    this.ira_selectedTambon = null;
                    return;
                }

                // First set province and wait for its options to load
                this.ifh_selectedProvince = {
                    province_id: val.province_id,
                    province_name: val.province
                };

                // Wait for province watcher to complete
                await this.$nextTick();

                // Load amphur options
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-amphur',
                            province_id: val.province_id
                        }
                    })
                    .then((response) => {
                        this.amphurOptions = response.data.data;

                        // Now set amphur
                        this.ira_selectedAmphur = {
                            amphur_id: val.amphur_id,
                            amphur_name: val.country
                        };
                    });

                // Wait for amphur watcher
                // await this.$nextTick();

                // Load tambon options
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-tambon',
                            amphur_id: val.amphur_id
                        }
                    })
                    .then((response) => {
                        this.tambonOptions = response.data.data;

                        // Finally set tambon
                        this.ira_selectedTambon = {
                            tambon_id: val.location_id,
                            tambon_name: val.subdistrict
                        };
                    });

                // Load community options

                // await this.$nextTick();

                await this.axios
                    .post(`${this.$url_service}/initial/community/option-1`, {
                        body: {
                            amphur: this.ira_selectedAmphur ? this.ira_selectedAmphur.amphur_name : null
                        }
                    })
                    .then((response) => {
                        this.communityOptions = response.data.data;

                        // Finally set tambon
                        this.ifh_community_name = {
                            community_id: val.community_id || '',
                            community_name: val.community_name
                        };
                    });

                await this.$nextTick();

                // Load fire station
                await this.axios
                    .post(`${this.$url_service}/initial/firestation`, {
                        body: {
                            topic: 'get-option-firestation',
                            userData: this.getUser()
                        }
                    })
                    .then((response) => {
                        this.FireStationOptions = response.data.data;

                        // Finally set tambon
                        this.ifh_FireStationSelected = {
                            fs_tname: val.fire_station
                        };
                    });
            } catch (error) {
                console.error('Error in selectedData watcher:', error);
            }
        },

        async selectedProvince(val) {
            // this.FireStationSelected = null
            this.communitySelect = null;
            this.selectedAmphur = null;

            if (val != null) {
                this.isDisabledAmphur = 0;
                // console.log(this.selectedProvince.province_id)
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-amphur',
                            province_id: this.selectedProvince.province_id
                        }
                    })
                    .then((response) => {
                        (this.amphurOptions = response.data.data),
                            this.amphurOptions.splice(0, 0, {
                                amphur_id: 'getall',
                                amphur_name: this.$i18n.t('selectAll')
                            });
                    });
                this.check_Fire_Form_search(this.selectedTambon, this.selectedAmphur, this.selectedProvince, 'search', true);
            } else {
                this.isDisabledAmphur = 1;
                this.selectedAmphur = null;
                await this.initialCommunityData();

                this.check_Fire_Form_search(this.selectedTambon, this.selectedAmphur, this.selectedProvince, 'search', true);
            }
        },
        async selectedAmphur(val) {
            // this.FireStationSelected = null
            this.communitySelect = null;
            this.selectedTambon = null;

            if (val != null) {
                this.isDisabledTambon = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-tambon',
                            amphur_id: this.selectedAmphur.amphur_id
                        }
                    })
                    .then((response) => {
                        (this.tambonOptions = response.data.data),
                            this.tambonOptions.splice(0, 0, {
                                tambon_id: 'getall',
                                tambon_name: this.$i18n.t('selectAll')
                            });
                    });
                await this.updateCommunityOptions(val.amphur_name);
                this.check_Fire_Form_search(this.selectedTambon, this.selectedAmphur, this.selectedProvince, 'search', true);
            } else {
                this.isDisabledTambon = 1;
                this.selectedTambon = null;
                // this.FireStationSelected = null
                this.check_Fire_Form_search(this.selectedTambon, this.selectedAmphur, this.selectedProvince, 'search', true);
                await this.initialCommunityData();
            }
        },
        async selectedTambon(val) {
            // this.FireStationSelected =null
            if (val != null) {
                this.check_Fire_Form_search(this.selectedTambon, this.selectedAmphur, this.selectedProvince, 'search', true);
            } else {
                this.selectedTambon = null;
                // this.FireStationSelected =null
                this.check_Fire_Form_search(this.selectedTambon, this.selectedAmphur, this.selectedProvince, 'search', true);
            }
        },
        async ifh_selectedProvince(val) {
            this.ifh_community_name = null;
            this.ira_selectedAmphur = null;

            if (val != null) {
                this.ira_isDisabledAmphur = 0;
                if (this.iP != 0) {
                    // this.ifh_FireStationSelected = null
                }
                this.iP++;

                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-amphur',
                            province_id: this.ifh_selectedProvince.province_id
                        }
                    })
                    .then((response) => {
                        // console.log(response)
                        this.amphurOptions = response.data.data;
                    });
                // this.Fire_Form()
                this.check_Fire_Form_search(this.ira_selectedTambon, this.ira_selectedAmphur, this.ifh_selectedProvince, 'form', true);
            } else {
                this.ira_isDisabledAmphur = 1;
                this.ira_selectedAmphur = null;
                await this.initialCommunityData();
                // this.ifh_FireStationSelected = null
                // this.Fire_Form()
                this.check_Fire_Form_search(this.ira_selectedTambon, this.ira_selectedAmphur, this.ifh_selectedProvince, 'form', true);
            }
        },

        async ira_selectedAmphur(val) {
            this.ifh_community_name = null;
            if (val != null) {
                this.ira_isDisabledTambon = 0;
                if (this.iA != 0) {
                    // this.ifh_FireStationSelected = null
                }
                this.iA++;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-tambon',
                            amphur_id: this.ira_selectedAmphur.amphur_id
                        }
                    })
                    .then((response) => (this.tambonOptions = response.data.data));
                // this.Fire_Form()
                await this.updateCommunityOptions(val.amphur_name);
                this.check_Fire_Form_search(this.ira_selectedTambon, this.ira_selectedAmphur, this.ifh_selectedProvince, 'form', true);
            } else {
                this.ira_isDisabledTambon = 1;
                this.ira_selectedTambon = null;
                // this.ifh_FireStationSelected = null
                // this.Fire_Form()
                this.check_Fire_Form_search(this.ira_selectedTambon, this.ira_selectedAmphur, this.ifh_selectedProvince, 'form', true);
                await this.initialCommunityData();
            }
        },

        async ira_selectedTambon(val) {
            if (val != null) {
                // console.log("this.selectedData.tambon_name",this.selectedData.tambon_name)
                // console.log("val.tambon_name",val.tambon_name)
                if (this.selectedData.tambon_name !== val.tambon_name) {
                    this.ifh_FireStationSelected = null;
                }

                // this.Fire_Form()
                this.check_Fire_Form_search(this.ira_selectedTambon, this.ira_selectedAmphur, this.ifh_selectedProvince, 'form', true);
            } else {
                // this.ifh_FireStationSelected = null
                // this.Fire_Form()
                this.check_Fire_Form_search(this.ira_selectedTambon, this.ira_selectedAmphur, this.ifh_selectedProvince, 'form', true);
            }
        },

        // Doe PDF เลือกได้
        columnsSelector(val) {
            if (val.length == 0) {
                this.FireHydrant_Table = [];
            } else {
                this.FireHydrant_Table = this.cloneTable;
            }
        }
    },
    created() {
        // Doe โหลด โทรศัพท์
        // Doe width 2/4
        window.addEventListener('resize', this.handleResize);
        this.handleResize();

        if (this.window.width <= 430) {
            this.searchMenu();
        } else {
            this.ms = true;
            this.searchMenu();
            // this.initialData();
        }
        // Doe โหลด โทรศัพท์

        // Doe PDF เลือกได้  4/5
        this.columnsSelector = this.columns;
        this.PDF_BodySizeSelect = this.PDF_BodySize;
        this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor;

        // for (let index = 0; index < this.columnsSelector.length; index++) {
        //     this.GetData_ColumnsSearch.push(this.columnsSelector[index].dataKey);
        // }

        // Doe PDF เลือกได้  4/5  จบ

        const decodedToken = this.decodeJWT(localStorage.getItem('token'));
        // this.initialData();
        this.checkRole = decodedToken.permission_id;

        this.checkView_data = decodedToken.view_data;
        this.checkAdd_data = decodedToken.add_data;
        this.checkEdit_data = decodedToken.edit_data;
        this.checkDelete_data = decodedToken.delete_data;

        // console.log(`checkRole = ${this.checkRole} `);
        // console.log(`checkView_data = ${this.checkView_data} `);
        // console.log(`checkAdd_data = ${this.checkAdd_data} `);
        // console.log(`checkEdit_data = ${this.checkEdit_data} `);
        // console.log(`checkDelete_data = ${this.checkDelete_data} `);

        this.Clone_Data_text_Footer = this.setCloneData(this.Data_text_Footer);
    },

    // Doe โหลด โทรศัพท์
    // Doe width 3/4
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    // Doe โหลด โทรศัพท์

    methods: {
        ...fnExtinguisher,
        checkLoginStatus() {
            const token = localStorage.getItem('token');
            const tokenExp = localStorage.getItem('token_exp');
            if (token && tokenExp) {
                const remainingTime = new Date(tokenExp) - Date.now();
                this.isLoggedIn = remainingTime > 0;
            } else {
                this.isLoggedIn = false;
            }
        },
        onUserLoggedIn() {
            this.checkLoginStatus();
        },

        async onQrEditRequest(fxId) {
            if (!fxId || !this.checkToken()) {
                return;
            }
            await this.editData(fxId);
        },

        async handleQrCodeSearch(code) {
            this.filter = code;
            this.paramsQuery = code;
            await this.searchFireHydrant();
            this.paramsQuery = '';

            const results = this.cloneTable.length ? this.cloneTable : this.FireHydrant_Table;
            if (!results || results.length === 0) {
                this.$fire({
                    type: 'error',
                    title: 'ไม่พบข้อมูล',
                    text: `ไม่พบข้อมูลถังดับเพลิงรหัส ${code}`,
                    confirmButtonColor: '#d33'
                });
            }

            this.$router.replace({ query: { ...this.$route.query, code: undefined } });
        },

        clearQrSearchLock() {
            this.ife_extinguisher_code = '';
            this.paramsQuery = '';
        },

        resetTableSearchPagination() {
            this.lazyParams = {
                ...this.lazyParams,
                first: 0,
                page: 1
            };
            this.currentPage = 1;
        },
        updateIsMobile() {
            this.isMobile = window.innerWidth <= 991;
        },
        getCookie(name) {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            if (parts.length === 2) return parts.pop().split(';').shift();
            return null;
        },

        handleLatInput() {
            if (this.ifh_lat) {
                // Format to exactly 6 decimal places
                this.ifh_lat = parseFloat(this.ifh_lat).toFixed(6);
                // Validate format (should be around 13.xxxxxx for Thailand)
                if (!/^1[3-4]\.\d{6}$/.test(this.ifh_lat)) {
                    this.error_ifh_lat_dot = true;
                } else {
                    this.error_ifh_lat_dot = false;
                    this.error_ifh_lat = false;
                    // Only try to update location data if both coordinates are valid
                    if (this.ifh_lon && /^100\.\d{6}$/.test(this.ifh_lon)) {
                        this.inputMap_latlon();
                    }
                }
            }
        },

        handleLonInput() {
            if (this.ifh_lon) {
                // Format to exactly 6 decimal places
                this.ifh_lon = parseFloat(this.ifh_lon).toFixed(6);
                // Validate format (should be around 100.xxxxxx for Thailand)
                if (!/^100\.\d{6}$/.test(this.ifh_lon)) {
                    this.error_ifh_lon_dot = true;
                } else {
                    this.error_ifh_lon_dot = false;
                    this.error_ifh_lon = false;
                    // Only try to update location data if both coordinates are valid
                    if (this.ifh_lat && /^1[3-4]\.\d{6}$/.test(this.ifh_lat)) {
                        this.inputMap_latlon();
                    }
                }
            }
        },

        async initialCommunityData() {
            this.loading = true;
            try {
                const response = await this.axios.post(`${this.$url_service}/initial/community/option-1`, {
                    amphur: this.ira_selectedAmphur
                        ? this.ira_selectedAmphur.amphur_name
                        : this.selectedAmphur
                        ? this.selectedAmphur.amphur_name
                        : null
                });
                this.communityOptions = response.data.data;
            } catch (error) {
                console.error('Error fetching community options:', error);
            } finally {
                this.loading = false;
            }
        },

        // eslint-disable-next-line no-unused-vars
        async updateCommunityOptions(amphur) {
            this.loading = true;
            try {
                const response = await this.axios.post(`${this.$url_service}/initial/community/option-1`, {
                    amphur: this.ira_selectedAmphur
                        ? this.ira_selectedAmphur.amphur_name
                        : this.selectedAmphur
                        ? this.selectedAmphur.amphur_name
                        : null
                });
                this.communityOptions = response.data.data;
            } catch (error) {
                console.error('Error fetching filtered community options:', error);
            } finally {
                this.loading = false;
            }
        },

        async updateLogs() {
            const userOrg = this.getUserOrganize(); //เช็คสิทธิ์
            const userId = this.getUsername();
            await this.axios
                .post(`${this.$url_service}/initial/extinguisher?user=${userId}`, {
                    body: {
                        topic: 'update-extinguisher-logs',
                        selectedFireHydrant: this.selectedFireHydrant,
                        userOrg: userOrg,
                        userData: this.getUser()
                    }
                })
                .then((response) => {
                    if (response) {
                        this.loadingCreate = false;
                        // โหลดเพิ่มแก้ไข 5/8 จบ
                        this.tempFor_displayConfirmationCloseModal = 'add';
                        this.FireHydrantModal = false;
                        this.$fire({
                            type: 'success',
                            title: 'ปรับปรุงข้อมูล',
                            text: 'ข้อมูลถังดับเพลิง',
                            timer: 3000,
                            confirmButtonColor: '#28B463'
                        });
                    }
                    // (this.check_duplicate = response.data.message)
                    // (this.initialData());
                    // this.searchFireHydrant()
                    // this.fastSearchFireHydrant()
                });
        },

        async updateDates() {
            try {
                this.loadingCreate = true;
                const userOrg = this.getUserOrganize();
                const userId = this.getUsername();

                // Format selected records
                const formattedRecords = this.selectedFireHydrant.map((item) => ({
                    fx_id: item.fx_id,
                    date_update: new Date().toISOString(),
                    // Include all other fields that need updating
                    ...item
                }));

                // console.log('formattedRecords', formattedRecords);

                const response = await this.axios.post(`${this.$url_service}/initial/extinguisher?user=${userId}`, {
                    body: {
                        topic: 'edit-extinguisher_date_multiple',
                        selectedFireHydrant: formattedRecords,
                        userOrg: userOrg,
                        userId: userId,
                        userData: this.getUser()
                    }
                });

                if (response.data.success) {
                    this.loadingCreate = false;
                    this.tempFor_displayConfirmationCloseModal = 'add';
                    this.FireHydrantModal = false;

                    // Refresh data
                    // await this.searchFireHydrant();

                    this.$fire({
                        type: 'success',
                        title: 'ปรับปรุงข้อมูล',
                        text: `อัปเดตข้อมูลถังดับเพลิงจำนวน ${response.data.updatedIds.length} รายการ`,
                        timer: 3000,
                        confirmButtonColor: '#28B463'
                    });
                    this.searchFireHydrant();
                }
            } catch (error) {
                this.loadingCreate = false;
                this.$fire({
                    type: 'error',
                    title: 'เกิดข้อผิดพลาด',
                    text: error.response?.data?.message || 'ไม่สามารถอัปเดตข้อมูลได้',
                    timer: 3000,
                    confirmButtonColor: '#DC3545'
                });
            }
        },

        onSelectAll(checked) {
            if (checked) {
                this.selectedFireHydrant = [...this.FireHydrant_Table];
            } else {
                this.selectedFireHydrant = [];
            }
            this.$emit('selectedFireHydrant', this.selectedFireHydrant);
            // console.log('selectedFireHydrant', this.selectedFireHydrant);
        },

        onSelectRow(row, checked) {
            if (checked) {
                if (!this.selectedFireHydrant.some((item) => item.fx_id === row.fx_id)) {
                    this.selectedFireHydrant.push(row);
                }
            } else {
                this.selectedFireHydrant = this.selectedFireHydrant.filter((item) => item.fx_id !== row.fx_id);
            }
            this.$emit('selectedFireHydrant', this.selectedFireHydrant);
            // console.log('selectedFireHydrant', this.selectedFireHydrant);
        },

        getUser1() {
            const getUser = localStorage.getItem('data');
            if (typeof getUser == 'string') {
                return JSON.parse(getUser);
            }
            return getUser;
        },

        getUser() {
            const getUser = this.decodeJWT(localStorage.getItem('token'));
            if (typeof getUser == 'string') {
                return JSON.parse(getUser);
            }
            return getUser;
        },

        saveData_Modal(ModalName) {
            if (ModalName === 'search') {
                if (!this.isFocused('TextBox_6_search') && !this.isFocused('TextBox_7_search')) {
                    // this.searchFireHydrant()
                    this.searchFireHydrant();
                }
            } else if (ModalName === 'Modal_Main') {
                if (
                    !this.isFocused('TextBox_2') &&
                    !this.isFocused('TextBox_3') &&
                    !this.isFocused('TextBox_10') &&
                    !this.isFocused('TextBox_11') &&
                    !this.isFocused('TextBox_12')
                ) {
                    this.saveData();
                }
            }
        },
        async exportCSV() {
            await this.searchAllFireHydrant();
            this.$refs.dt.exportCSV();
        },

        async Fire_Form_search(status) {
            if (this.ifh_lon != '') {
                return;
            }

            // Load fire station options if not already loaded
            if (!this.FireStationOptions_Form_main.length) {
                await this.Fire_Form();
            }

            if (status == 'search') {
                // Set FireStationOptions_AT without adding "selectAll" if it already exists
                this.FireStationOptions_AT = [...this.FireStationOptions_Form_main];

                // Add "selectAll" option only if it doesn't already exist
                if (
                    this.FireStationOptions_AT.length > 0 &&
                    !this.FireStationOptions_AT.some((option) => option.fs_tname === this.$i18n.t('selectAll'))
                ) {
                    this.FireStationOptions_AT.unshift({
                        fs_tname: this.$i18n.t('selectAll')
                    });
                }
            }

            this.FireStationOptions_Form = this.FireStationOptions_Form_main;
            return;
        },
        check_Fire_Form_search(Tambon, Amphur, Province, status, clear) {
            if (Tambon !== null && Amphur !== null && Province !== null) {
                if (Tambon.tambon_id === 'getall') {
                    if (Province.province_id === 'getall') {
                        this.Dropdown_Fire_type = '';
                        this.Dropdown_Fire_boundary = 'all';
                        this.Dropdown_Fire_id = '';
                    } else if (Amphur.amphur_id === 'getall') {
                        this.Dropdown_Fire_type = '';
                        this.Dropdown_Fire_boundary = 'province';
                        this.Dropdown_Fire_id = Province.province_id;
                    } else {
                        this.Dropdown_Fire_type = '';
                        this.Dropdown_Fire_boundary = 'amphoe';
                        this.Dropdown_Fire_id = Amphur.amphur_id;
                    }
                } else {
                    this.Dropdown_Fire_type = '';
                    this.Dropdown_Fire_boundary = 'tambon';
                    this.Dropdown_Fire_id = Tambon.tambon_id;
                }
            } else if (Amphur !== null && Province !== null) {
                if (Amphur.amphur_id === 'getall') {
                    if (Province.province_id === 'getall') {
                        this.Dropdown_Fire_type = '';
                        this.Dropdown_Fire_boundary = 'all';
                        this.Dropdown_Fire_id = '';
                    } else {
                        this.Dropdown_Fire_type = '';
                        this.Dropdown_Fire_boundary = 'province';
                        this.Dropdown_Fire_id = Province.province_id;
                    }
                } else {
                    this.Dropdown_Fire_type = '';
                    this.Dropdown_Fire_boundary = 'amphoe';
                    this.Dropdown_Fire_id = Amphur.amphur_id;
                }
            } else if (Province !== null) {
                if (Province.province_id === 'getall') {
                    this.Dropdown_Fire_type = '';
                    this.Dropdown_Fire_boundary = 'all';
                    this.Dropdown_Fire_id = '';
                } else {
                    this.Dropdown_Fire_type = '';
                    this.Dropdown_Fire_boundary = 'province';
                    this.Dropdown_Fire_id = Province.province_id;
                }
            } else {
                this.Dropdown_Fire_type = '';
                this.Dropdown_Fire_boundary = 'all';
                this.Dropdown_Fire_id = '';
            }

            if (status === 'search') {
                if (clear === true) {
                    this.FireStationSelected = null;
                }

                this.Fire_Form_search(status);
            } else {
                if (this.selectedData == '') {
                    this.ifh_FireStationSelected = null;
                } else if (Tambon === null || Amphur === null || Province === null) {
                    this.ifh_FireStationSelected = null;
                }
                this.Fire_Form_search(status);
            }
        },

        async Fire_Form() {
            if (this.selectedData == '') {
                // this.ifh_FireStationSelected = null
            }

            // this.selectedProvince = null
            await this.axios
                .post(`${this.$url_service}/initial/firestation`, {
                    body: {
                        topic: 'get-option-firestation',
                        // province_id:this.ifh_selectedProvince == null ? "" :
                        // this.ifh_selectedProvince.province_id == "getall" ? ""
                        // : this.ifh_selectedProvince.province_id,
                        // amphur_id:this.ira_selectedAmphur == null ? "" :
                        // this.ira_selectedAmphur.amphur_id == "getall" ? ""
                        // : this.ira_selectedAmphur.amphur_id,
                        // tambon_id:this.ira_selectedTambon == null ? "" :
                        // this.ira_selectedTambon.tambon_id == "getall" ? ""
                        // : this.ira_selectedTambon.tambon_id
                        province_id: '',
                        amphur_id: '',
                        userData: this.getUser1(),
                        tambon_id: ''
                    }
                })
                .then((response) => {
                    this.FireStationOptions_Form = response.data.data;
                    this.FireStationOptions_Form_main = response.data.data;
                    // console.log("this.FireStationOptions_AT",this.FireStationOptions_AT)
                });

            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-01' }
                })
                .then((response) => {
                    this.organizeTypeOptions_Form = response.data.data.filter(
                        (option) => option.system_name && option.system_name.includes('สำนักงานเขต')
                    );
                });
        },

        // Doe โหลด โทรศัพท์
        // Doe width 4/4
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;

            this.table_BOXmanege = window.innerWidth > 700 ? 'p-field p-col' : '';
            this.table_editBTN = window.innerWidth > 700 ? this.$i18n.t('editBtn') : '';
            this.table_deleteBTN = window.innerWidth > 700 ? this.$i18n.t('deleteBtn') : '';
            this.table_genQR = window.innerWidth > 700 ? this.$i18n.t('qrCodeBtn') : '';
            if (window.innerWidth > 700) {
                this.table_headerStyle = this.checkInnerWidth('15rem', 'Column');
                this.table_bodyStyle = this.checkInnerWidth('15rem', 'Body');
            } else {
                this.table_headerStyle = this.checkInnerWidth('105px', 'Column');
                this.table_bodyStyle = this.checkInnerWidth('105px', 'Body');
            }
        },

        async searchMenu() {
            // console.log("79")
            await this.axios
                .post(`${this.$url_service}/general/country`, {
                    body: {
                        topic: 'get-province'
                    }
                })
                .then((response) => {
                    this.provinceOptions = response.data.data;
                    // this.provinceOptions.splice(0, 0, {
                    //   province_id: "getall",
                    //   province_name: this.$i18n.t("selectAll"),
                    // });
                });

            this.check_Fire_Form_search(this.selectedTambon, this.selectedAmphur, this.selectedProvince, 'search', true);

            await this.axios
                .post(`${this.$url_service}/initial/firestation`, {
                    body: {
                        topic: 'get-option-firestation',
                        userData: this.getUser()
                    }
                })
                .then((response) => {
                    this.FireStationOptions = response.data.data;
                    // this.FireStationOptions.splice(0, 0, {
                    //     fs_id : "getall",
                    //     fs_tname: this.$i18n.t("selectAll"),
                    //   });
                    // console.log("this.FireStationOptions",this.FireStationOptions)
                });
        },

        // Doe โหลด โทรศัพท์

        // Doe ค้นหา  3/6

        async search() {
            // Store reference to the input element
            if (event && event.target) {
                this.searchInputRef = event.target;
            }

            // Cancel any existing timeout
            if (this.searchTimeout) {
                clearTimeout(this.searchTimeout);
            }

            // Use debounce to delay processing
            this.searchTimeout = setTimeout(async () => {
                try {
                    if (this.isMobile) {
                        this.clearQrSearchLock();
                    }

                    if (!this.filter?.trim()) {
                        this.isSearchMode = false;
                        return await this.searchFireHydrant();
                    }

                    this.error = null;
                    this.isSearchMode = true;
                    this.resetTableSearchPagination();
                    // this.loading = true;

                    const searchFields = [
                        { enabled: this.columns_place_name, field: 'place_name' },
                        { enabled: this.columns_code, field: 'code' },
                        { enabled: this.columns_type, field: 'type' },
                        { enabled: this.columns_extinguisher_size, field: 'fire_extinguisher_size' },
                        { enabled: this.columns_location_type, field: 'location_type' },
                        { enabled: this.columns_status, field: 'status' },
                        { enabled: this.columns_extinguisher_status, field: 'extinguisher_status' },
                        { enabled: this.columns_amphur, field: 'country' },
                        { enabled: this.columns_tambon, field: 'subdistrict' },
                        { enabled: this.columns_community_name, field: 'community_name' },
                        { enabled: this.columns_lat, field: 'lat' },
                        { enabled: this.columns_lon, field: 'lon' },
                        { enabled: this.columns_fire_station, field: 'fire_station' },
                        { enabled: this.columns_details, field: 'details' },
                        { enabled: this.columns_date_expire, field: 'date_expire' },
                        { enabled: this.columns_date_created, field: 'date_created' },
                        { enabled: this.columns_date_update, field: 'date_update' }
                    ]
                        .filter(({ enabled }) => enabled)
                        .map(({ field }) => field);

                    if (!searchFields.length) {
                        this.error = 'Please enable at least one search column';
                        return;
                    }

                    const response = await this.axios.post(`${this.$url_service}/initial/extinguisher`, {
                        body: {
                            topic: 'filter-table',
                            filter: this.filter,
                            fields: searchFields,
                            pagination: {
                                page: this.lazyParams.page || 1,
                                limit: this.lazyParams.rows || 10
                            },
                            userData: this.getUser(),
                            userOrg: this.checkPermission() ? null : this.getUserOrganize()
                        }
                    });

                    if (response.data) {
                        // Apply the same formatting as in searchFireHydrant
                        this.FireHydrant_Table = response.data.data;
                        this.cloneTable = response.data.data;
                        this.lazyParams.totalRecords = response.data.total;

                        // Apply the same formatting logic as searchFireHydrant
                        await this.formatData(this.FireHydrant_Table);
                    }

                    this.currentPage = this.lazyParams.page;
                } catch (error) {
                    console.error('Error fetching filtered data:', error);
                    this.error = 'Failed to fetch data. Please try again.';
                    this.isSearchMode = false;
                    await this.searchFireHydrant();
                } finally {
                    this.loading = false;

                    // Restore focus to input element after rendering completes
                    this.$nextTick(() => {
                        if (this.searchInputRef) {
                            this.searchInputRef.focus();

                            // Place cursor at the end of the text
                            const length = this.searchInputRef.value.length;
                            this.searchInputRef.setSelectionRange(length, length);
                        }
                    });
                }
            }, 400);
        },

        normalizeItem(item) {
            const fieldsToCheck = ['tambon_name', 'amphur_name', 'province_name'];
            fieldsToCheck.forEach((field) => {
                if (!item[field] || item[field] === 'null') {
                    item[field] = '-';
                }
            });
        },

        updateIndexes() {
            this.FireHydrant_Table.forEach((item, index) => {
                item.index = index + 1;
            });
        },

        // Doe ค้นหา  3/6 จบ

        async initialData() {
            this.ms = true;
            this.filter = '';
            this.cloneTable = [];
            this.loading = true;
            // console.log("4444")
            await this.axios
                .post(`${this.$url_service}/initial/firehydrant`, {
                    body: {
                        topic: 'get-table-firehydrant',
                        userOrg: this.checkPermission() ? null : this.getUserOrganize()
                    }
                })
                // Doe : เพิ่ม ลำดับ 3/4
                .then((response) => {
                    this.FireHydrant_Table = response.data.data;
                    // Doe ค้นหา  4/6
                    this.cloneTable = response.data.data;
                    // Doe ค้นหา  4/6

                    // Doe ช่องว่างใส่ ขีด
                    this.formatData(this.FireHydrant_Table);
                });
            // Doe : เพิ่ม ลำดับ 3/4 จบ

            if (this.columns_disabled == true) {
                this.FireHydrant_Table = this.cloneTable;
            } else {
                this.FireHydrant_Table = [];
            }

            await this.axios
                .post(`${this.$url_service}/general/country`, {
                    body: {
                        topic: 'get-province'
                    }
                })
                .then((response) => {
                    this.provinceOptions = response.data.data;
                    // this.provinceOptions.splice(0, 0, {
                    //   province_id: "getall",
                    //   province_name: this.$i18n.t("selectAll"),
                    // });
                });

            this.check_Fire_Form_search(this.selectedTambon, this.selectedAmphur, this.selectedProvince, 'search', true);

            await this.axios
                .post(`${this.$url_service}/initial/firestation`, {
                    body: {
                        topic: 'get-option-firestation',
                        userData: this.getUser()
                    }
                })
                .then((response) => {
                    this.FireStationOptions = response.data.data;
                    // this.FireStationOptions.splice(0, 0, {
                    //     fs_id : "getall",
                    //     fs_tname: this.$i18n.t("selectAll"),
                    //   });
                    // console.log("this.FireStationOptions",this.FireStationOptions)
                });
            this.loading = false;
        },

        formatData(data) {
            const startIndex = (this.lazyParams.page - 1) * this.lazyParams.rows;

            return data.map((item, index) => {
                // Helper function for null/empty checks
                const setDefaultIfEmpty = (value) => {
                    return value == null || value === 'null' || value === '' ? '-' : value;
                };

                // Format coordinates if they exist
                const formatCoordinate = (coord) => {
                    return coord === '-' ? coord : parseFloat(coord).toFixed(6);
                };

                // Format dates
                const formatDate = (date) => {
                    return date === '-' ? date : this.changeDateToThai(this.checkDate(date));
                };

                // Update item with pagination index
                item.index = startIndex + index + 1;

                // Basic fields defaulting to '-'
                const fieldsToCheck = [
                    'image_cloud',
                    'place_name',
                    'code',
                    'type',
                    'fire_extinguisher_size',
                    'location_type',
                    'tambon_name',
                    'amphur_name',
                    'province_name',
                    'fire_station',
                    'details'
                ];

                fieldsToCheck.forEach((field) => {
                    item[field] = setDefaultIfEmpty(item[field]);
                });

                // Handle coordinates
                item.lat = setDefaultIfEmpty(item.lat);
                item.lon = setDefaultIfEmpty(item.lon);
                if (item.lat !== '-') item.lat = formatCoordinate(item.lat);
                if (item.lon !== '-') item.lon = formatCoordinate(item.lon);

                // Handle dates
                ['date_expire', 'date_created', 'date_update'].forEach((dateField) => {
                    item[dateField] = setDefaultIfEmpty(item[dateField]);
                    if (item[dateField] !== '-') {
                        item[dateField] = formatDate(item[dateField]);
                    }
                });

                // Check organization status
                item.statusOrganize = ['latch_lock', 'joystick', 'pressure_gauge', 'line_spray', 'chassis'].every((prop) => item[prop] === 'TRUE')
                    ? 'ปกติ'
                    : 'ชำรุด';

                return item;
            });
        },

        onFileChange(e) {
            document.getElementById('fireHydrant_uploadImageFile').click();

            if (e.type !== 'click') {
                if (e.target.files[0] != undefined) {
                    //  let imgSize = e.target.files[0]
                    // if (imgSize.size > 7340032) {
                    //   this.$fire({
                    //         type: "warning",
                    //         title:"ขนาดไฟล์ใหญ่เกินไป",
                    //         text: "กรุณาใส่เฉพาะไฟล์รูปภาพไม่เกิน 7 MB.",
                    //         timer: 3000,
                    //         confirmButtonColor: '#28B463',
                    //       });
                    //       this.clearImage()
                    // }else{
                    if (e.target.files[0].type.split('/')[0] == 'image') {
                        const file = e.target.files[0];
                        this.imageName = file.name;
                        this.url = URL.createObjectURL(file);

                        var reader = new FileReader();

                        reader.onload = (e) => {
                            var img = document.createElement('img');
                            img.onload = () => {
                                var canvas = document.createElement('canvas');
                                var ctx = canvas.getContext('2d');
                                ctx.drawImage(img, 0, 0);

                                var MAX_WIDTH = 250;
                                var MAX_HEIGHT = 250;
                                var width = img.width;
                                var height = img.height;

                                if (width > height) {
                                    if (width > MAX_WIDTH) {
                                        height *= MAX_WIDTH / width;
                                        width = MAX_WIDTH;
                                    }
                                } else {
                                    if (height > MAX_HEIGHT) {
                                        width *= MAX_HEIGHT / height;
                                        height = MAX_HEIGHT;
                                    }
                                }
                                canvas.width = width;
                                canvas.height = height;
                                ctx = canvas.getContext('2d');
                                ctx.drawImage(img, 0, 0, width, height);

                                var dataurl = canvas.toDataURL('image/png');
                                let console = {};
                                let logger = document.getElementById('io_image');
                                console.log = (text) => {
                                    let txt = document.createTextNode(text);
                                    logger.appendChild(txt);
                                };
                                console.log(dataurl);
                            };
                            img.src = e.target.result;
                        };
                        reader.readAsDataURL(file);
                    } else {
                        // this.$toast.add({
                        //   severity: "error",
                        //   summary: "ประเภทไฟล์ผิดพลาด",
                        //   detail: "กรุณาใส่เฉพาะไฟล์รูปภาพเท่านั้น",
                        //   life: 3000,
                        // });
                        this.$fire({
                            type: 'error',
                            title: 'ประเภทไฟล์ผิดพลาด',
                            text: 'กรุณาใส่เฉพาะไฟล์รูปภาพเท่านั้น',
                            timer: 3000,
                            confirmButtonColor: '#28B463'
                        });
                        this.url = null;
                        document.getElementById('fireHydrant_uploadImageFile').value = '';
                    }
                    // }
                } else {
                    this.url = null;
                }
            }
        },

        clearImage() {
            this.url = null;
            document.getElementById('fireHydrant_uploadImageFile').value = '';
        },

        showImage(data) {
            const resolved = this.resolveImageSrc(data);
            if (!resolved) {
                this.imgTable = null;
            } else {
                this.imgTable = [resolved];
            }
            this.displayBasic2 = true;
        },

        closeAllModal() {
            // console.log("Close and don`t save data");
            this.FireHydrantModal = false;
            this.displayConfirmationCloseModal = false;
            this.clearData();
        },

        someHandler(message) {
            if (message == 'ch-province') {
                this.ira_selectedAmphur = null;
            }
            if (message == 'ch-amphur') {
                this.ira_selectedTambon = null;
            }
        },
        acceptNumberPhone() {
            var x = this.iex_extinguisher_size.replace(/\D/g, '');
            this.iex_extinguisher_size = x;
        },

        async searchAllFireHydrant() {
            this.isSearchMode = false;
            this.ms = true;
            // this.filter='';
            this.cloneTable = [];
            this.loading = true;

            //   console.log('community_name object:', this.community_name);
            // console.log('community_name value being sent:', this.community_name !== null ? this.community_name.community_name : '');

            await this.axios
                .post(`${this.$url_service}/initial/extinguisher`, {
                    body: {
                        topic: 'search-all-table',
                        place_name: this.place_name,
                        type: this.type === 'เลือกทั้งหมด' ? '' : this.type,
                        location_type: this.location_type === '' ? '' : this.location_type,
                        extinguisher_size: this.extinguisher_size === '' ? '' : this.extinguisher_size,
                        province: this.selectedProvince,
                        community_name: this.community_name !== null ? this.community_name.community_name : '',
                        amphur: this.selectedAmphur,
                        tambon: this.selectedTambon,
                        fire_station: this.FireStationSelected,
                        code: this.paramsQuery == '' ? null : this.paramsQuery,
                        userData: this.getUser(),
                        ife_extinguisher_code: this.ife_extinguisher_code,
                        iex_extinguisher_status_search: this.iex_extinguisher_status_search,
                        userOrg: this.checkPermission() ? null : this.getUserOrganize(), //เช็คสิทธิ์
                        status_code: this.status_code,
                        start_date: this.start_date,
                        end_date: this.end_date,
                        filter_date_field: this.filter_date_field
                    }
                })
                // Doe : เพิ่ม ลำดับ 4/4
                .then((response) => {
                    console.log(response.data.data);
                    this.FireHydrant_Table = response.data.data;
                    // console.log(response)
                    // Doe ค้นหา  5/6
                    this.cloneTable = response.data.data;
                    // Doe ค้นหา  5/6

                    this.formatData(this.FireHydrant_Table);
                    // console.log("this.FireHydrant_Table == id  ",this.FireHydrant_Table)

                    // this.search()
                    this.setSearchText_Footer();
                });
            // Doe : เพิ่ม ลำดับ 4/4 จบ

            if (this.columns_disabled == true) {
                this.FireHydrant_Table = this.cloneTable;
            } else {
                this.FireHydrant_Table = [];
            }

            // this.search();
            this.loading = false;
        },

        async searchFireHydrant() {
            try {
                this.loading = true;
                this.ms = true;

                const filters = {
                    place_name: this.place_name,
                    type: this.type === 'เลือกทั้งหมด' ? '' : this.type,
                    location_type: this.location_type === '' ? '' : this.location_type,
                    community_name: this.community_name !== null ? this.community_name.community_name : '',
                    extinguisher_size: this.extinguisher_size === '' ? '' : this.extinguisher_size,
                    province: this.processLocationFilter(this.selectedProvince),
                    amphur: this.processLocationFilter(this.selectedAmphur),
                    tambon: this.processLocationFilter(this.selectedTambon),
                    fire_station: this.FireStationSelected,
                    code: this.paramsQuery == '' ? null : this.paramsQuery,
                    iex_extinguisher_status_search: this.iex_extinguisher_status_search,
                    ife_extinguisher_code: this.ife_extinguisher_code,
                    status_code: this.status_code,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    filter_date_field: this.filter_date_field
                };

                const response = await this.axios.post(`${this.$url_service}/initial/extinguisher`, {
                    body: {
                        topic: 'search-table',
                        filters: filters,
                        pagination: {
                            page: this.lazyParams.page,
                            limit: this.lazyParams.rows
                        },
                        userData: this.getUser(),
                        userOrg: this.checkPermission() ? null : this.getUserOrganize()
                    }
                });

                if (response.data) {
                    this.FireHydrant_Table = response.data.data;
                    this.cloneTable = response.data.data;
                    this.lazyParams.totalRecords = response.data.total;
                    await this.formatData(this.FireHydrant_Table);
                    this.setSearchText_Footer();
                }

                if (this.columns_disabled) {
                    this.FireHydrant_Table = this.cloneTable;
                } else {
                    this.FireHydrant_Table = [];
                }
            } catch (error) {
                console.error('Search error:', error);
            } finally {
                this.loading = false;
            }
        },

        // Helper method to process location filters
        processLocationFilter(location) {
            if (!location) return null;
            if (location.province_id === 'getall' || location.amphur_id === 'getall' || location.tambon_id === 'getall') {
                return null; // Return null to indicate "select all"
            }
            return location;
        },

        //new
        onPage(event) {
            const newPage = Math.floor(event.first / event.rows) + 1;

            this.lazyParams = {
                first: event.first,
                rows: event.rows,
                page: newPage,
                totalRecords: this.lazyParams.totalRecords
            };

            // Only fetch new data if page actually changed
            if (newPage !== this.currentPage) {
                this.currentPage = newPage;
                if (this.isSearchMode) {
                    this.search();
                } else {
                    this.searchFireHydrant();
                }
            }
        },

        setSearchText_Footer() {
            this.text_Footer = false;
            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            if (
                this.place_name !== '' ||
                this.type !== '' ||
                this.extinguisher_size !== '' ||
                this.location_type !== '' ||
                this.amphur !== null ||
                this.tambon !== null ||
                this.province !== null ||
                this.fire_station !== null
            ) {
                for (let index = 0; index < this.Data_text_Footer.length; index++) {
                    const element = this.Data_text_Footer[index];
                    if (element.DataName === 'ขนาดถังดับเพลิง' && this.extinguisher_size !== '') {
                        element.textShow = `${this.extinguisher_size} ปอนด์`;
                    }
                    if (element.DataName === 'ชื่อสถานที่' && this.place_name !== '') {
                        element.textShow = this.place_name;
                    }
                    if (element.DataName === 'ประเภท' && this.type !== '') {
                        element.textShow = this.type;
                    }
                    if (element.DataName === 'ประเภทสถานที่' && this.location_type !== '') {
                        element.textShow = this.location_type;
                    }
                    if (element.DataName === 'เขต/อำเภอ' && this.selectedAmphur !== null) {
                        element.textShow = this.selectedAmphur.amphur_name;
                    }
                    if (element.DataName === 'แขวง/ตำบล' && this.selectedTambon !== null) {
                        element.textShow = this.selectedTambon.tambon_name;
                    }
                    // if(element.DataName === "ละติจูด" && this.selectedTambon !== null ){
                    //   element.textShow = this.
                    // }
                    // if (element.DataName === "ลองจิจูด" && this.FireStationSelected !== null) {
                    //   element.textShow = this.FireStationSelected.fs_tname
                    // }
                    if (element.DataName === 'หน่วยงานรับผิดชอบ' && this.FireStationSelected !== null) {
                        element.textShow = this.FireStationSelected;
                    }
                    // if (element.DataName === "รายละเอียดการตรวจสอบ" && this.inspec_details !== "") {
                    //   element.textShow = this.inspec_details
                    // }
                }
                this.text_Footer = true;
            }
        },
        selectMap_passValue(variable) {
            this.ifh_lat = variable.lat.toFixed(6);
            this.ifh_lon = variable.lng.toFixed(6);
        },
        selectMap_displayMap() {
            this.displayMap = false;

            // แจ้งเตือนกรณีไม่ได้ ข้อมูลพิกัด

            if (this.ifh_lat !== null && this.ifh_lon !== null && this.ifh_lat !== '' && this.ifh_lon !== '') {
                this.$fire({
                    title: 'เพิ่มพิกัดสำเร็จ',
                    // text: "ข้อมูลพิกัด",
                    type: 'success',
                    timer: 3000,
                    confirmButtonColor: '#28B463'
                });
            } else {
                this.$fire({
                    title: 'ยังไม่ได้เลือกข้อมูลพิกัด',
                    // text: "ยังไม่ได้เลือกข้อมูลพิกัด",
                    type: 'warning',
                    timer: 3000,
                    confirmButtonColor: '#28B463'
                });
            }
        },

        //  Doe เพิ่มหมุด map V.2 6/9  -->

        // async inputMap_latlon() {
        //     if (this.ifh_lat !== '' && this.ifh_lat !== null && this.ifh_lon !== '' && this.ifh_lon !== null) {
        //         try {
        //             const response = await this.axios.get(
        //                 `https://api.deemap.com/service/geocode/lat=${this.ifh_lat}/lon=${this.ifh_lon}/key=0feb00d7e64c5686bf434b9b90ab2d3c`
        //             );

        //             if (response.data.data.length > 0) {
        //                 const data = {
        //                     ADMIN_CODE: response.data.data[0].ADMIN_CODE,
        //                     provinceName: response.data.data[0].PROV_TNAME,
        //                     amphurName: response.data.data[0].AMP_TNAME,
        //                     tambonName: response.data.data[0].TAM_TNAME,
        //                     postCODE: response.data.data[0].POSTCOD
        //                 };

        //                 const element = data.ADMIN_CODE;
        //                 const country_ID = `${element[0]}${element[1]}`;
        //                 const land_ID = `${element[2]}${element[3]}`;
        //                 const province_ID = `${element[4]}${element[5]}`;
        //                 const amphur_ID = `${element[4]}${element[5]}${element[6]}${element[7]}`;
        //                 const tambon_ID = `${element[4]}${element[5]}${element[6]}${element[7]}${element[8]}${element[9]}`;

        //                 if (country_ID == '66' && land_ID !== '00') {
        //                     // console.log('Valid location found, loading options...');

        //                     // Step 1: Reset all selections first
        //                     this.ifh_selectedProvince = null;
        //                     this.ira_selectedAmphur = null;
        //                     this.ira_selectedTambon = null;

        //                     // Step 2: Load province options (should already be loaded, but confirm)
        //                     await this.$nextTick();

        //                     // Step 3: Set province and load amphur options
        //                     this.ifh_selectedProvince = {
        //                         province_name: data.provinceName,
        //                         province_id: province_ID
        //                     };

        //                     // Load amphur options - critical step!
        //                     // console.log("Loading amphur options for province ID:", province_ID);
        //                     await this.loadAmphurOptions(province_ID);
        //                     await this.$nextTick();

        //                     // Step 4: Set amphur and load tambon options
        //                     this.ira_selectedAmphur = {
        //                         amphur_name: data.amphurName,
        //                         amphur_id: amphur_ID
        //                     };

        //                     // Load tambon options
        //                     // console.log("Loading tambon options for amphur ID:", amphur_ID);
        //                     await this.loadTambonOptions(amphur_ID);
        //                     await this.$nextTick();

        //                     // Step 5: Finally set tambon
        //                     this.ira_selectedTambon = {
        //                         tambon_name: data.tambonName,
        //                         tambon_id: tambon_ID
        //                     };

        //                     this.error_latlon_country = false;
        //                     this.error_latlon_land = false;
        //                     this.error_latlon_P = false;
        //                     this.error_latlon_A = false;
        //                     this.error_latlon_T = false;

        //                     // Force UI update
        //                     this.$forceUpdate();
        //                 } else {
        //                     // Handle error conditions...
        //                     if (country_ID !== '66') {
        //                         this.error_latlon_country = true;
        //                     } else {
        //                         this.error_latlon_country = false;
        //                     }
        //                     // ... other error handling

        //                     this.ifh_selectedProvince = null;
        //                     this.ira_selectedAmphur = null;
        //                     this.ira_selectedTambon = null;
        //                 }
        //             } else {
        //                 this.resetLocationSelections();
        //             }
        //         } catch (error) {
        //             console.error('Error in inputMap_latlon:', error);
        //             this.resetLocationSelections();
        //         }
        //     } else {
        //         this.resetLocationSelections();
        //     }
        // },

        async inputMap_latlon() {
            if (this.ifh_lat !== '' && this.ifh_lat !== null && this.ifh_lon !== '' && this.ifh_lon !== null) {
                try {
                    this.locationLoading = true; // Show loading indicator

                    const response = await this.axios.get(
                        `https://api.deemap.com/service/geocode/lat=${this.ifh_lat}/lon=${this.ifh_lon}/key=0feb00d7e64c5686bf434b9b90ab2d3c`
                    );

                    if (response.data.data.length > 0) {
                        const data = {
                            ADMIN_CODE: response.data.data[0].ADMIN_CODE,
                            provinceName: response.data.data[0].PROV_TNAME,
                            amphurName: response.data.data[0].AMP_TNAME,
                            tambonName: response.data.data[0].TAM_TNAME,
                            postCODE: response.data.data[0].POSTCOD
                        };

                        const element = data.ADMIN_CODE;
                        const country_ID = `${element[0]}${element[1]}`;
                        const land_ID = `${element[2]}${element[3]}`;
                        const province_ID = `${element[4]}${element[5]}`;
                        const amphur_ID = `${element[4]}${element[5]}${element[6]}${element[7]}`;
                        const tambon_ID = `${element[4]}${element[5]}${element[6]}${element[7]}${element[8]}${element[9]}`;

                        if (country_ID == '66' && land_ID !== '00') {
                            // Reset all selections first to avoid watchers interfering with each other
                            this.ifh_selectedProvince = null;
                            this.ira_selectedAmphur = null;
                            this.ira_selectedTambon = null;

                            await this.$nextTick();

                            // Step 1: Directly load all options we need
                            // Load province options (should already be loaded, but let's make sure)
                            const provinceResponse = await this.axios.post(`${this.$url_service}/general/country`, {
                                body: { topic: 'get-province' }
                            });
                            this.provinceOptions = provinceResponse.data.data;

                            // Load amphur options for this province
                            const amphurResponse = await this.axios.post(`${this.$url_service}/general/country`, {
                                body: {
                                    topic: 'get-amphur',
                                    province_id: province_ID
                                }
                            });
                            this.amphurOptions = amphurResponse.data.data;
                            this.ira_isDisabledAmphur = 0;

                            // Load tambon options for this amphur
                            const tambonResponse = await this.axios.post(`${this.$url_service}/general/country`, {
                                body: {
                                    topic: 'get-tambon',
                                    amphur_id: amphur_ID
                                }
                            });
                            this.tambonOptions = tambonResponse.data.data;
                            this.ira_isDisabledTambon = 0;

                            // Step 2: Now set all values in correct order
                            this.ifh_selectedProvince = {
                                province_name: data.provinceName,
                                province_id: province_ID
                            };

                            await this.$nextTick(); // Allow UI to update

                            this.ira_selectedAmphur = {
                                amphur_name: data.amphurName,
                                amphur_id: amphur_ID
                            };

                            await this.$nextTick(); // Allow UI to update

                            this.ira_selectedTambon = {
                                tambon_name: data.tambonName,
                                tambon_id: tambon_ID
                            };

                            // Reset all error flags
                            this.error_latlon_country = false;
                            this.error_latlon_land = false;
                            this.error_latlon_P = false;
                            this.error_latlon_A = false;
                            this.error_latlon_T = false;

                            // Step 3: Update community options based on the selected amphur
                            if (this.ira_selectedAmphur) {
                                await this.updateCommunityOptions(data.amphurName);
                            }

                            // Step 4: Update fire station options
                            await this.check_Fire_Form_search(
                                this.ira_selectedTambon,
                                this.ira_selectedAmphur,
                                this.ifh_selectedProvince,
                                'form',
                                true
                            );
                        } else {
                            this.handleLocationErrors(country_ID, data);
                        }
                    } else {
                        this.resetLocationSelections();
                    }
                } catch (error) {
                    console.error('Error in reverse geocoding:', error);
                    this.resetLocationSelections();
                } finally {
                    this.locationLoading = false; // Hide loading indicator
                }
            } else {
                this.resetLocationSelections();
            }
        },

        // Helper method to handle location errors
        handleLocationErrors(country_ID, data) {
            if (country_ID !== '66') {
                this.error_latlon_country = true;
            } else {
                this.error_latlon_country = false;
            }

            this.error_latlon_P = !data.provinceName || data.provinceName === 'null' || data.provinceName === '';
            this.error_latlon_A = !data.amphurName || data.amphurName === 'null' || data.amphurName === '';
            this.error_latlon_T = !data.tambonName || data.tambonName === 'null' || data.tambonName === '';

            this.ifh_selectedProvince = null;
            this.ira_selectedAmphur = null;
            this.ira_selectedTambon = null;
        },

        async loadAmphurOptions(provinceId) {
            if (!provinceId) return;

            try {
                // Enable the dropdown first
                this.ira_isDisabledAmphur = 0;

                const response = await this.axios.post(`${this.$url_service}/general/country`, {
                    body: {
                        topic: 'get-amphur',
                        province_id: provinceId
                    }
                });

                this.amphurOptions = response.data.data;
                // console.log('Loaded', this.amphurOptions.length, 'amphur options');
            } catch (error) {
                console.error('Failed to load amphur options:', error);
                this.ira_isDisabledAmphur = 1;
            }
        },

        // Helper method to load tambon options
        async loadTambonOptions(amphurId) {
            if (!amphurId) return;

            try {
                // Enable the dropdown first
                this.ira_isDisabledTambon = 0;

                const response = await this.axios.post(`${this.$url_service}/general/country`, {
                    body: {
                        topic: 'get-tambon',
                        amphur_id: amphurId
                    }
                });

                this.tambonOptions = response.data.data;
                // console.log('Loaded', this.tambonOptions.length, 'tambon options');
            } catch (error) {
                console.error('Failed to load tambon options:', error);
                this.ira_isDisabledTambon = 1;
            }
        },

        // Helper method to reset all location selections
        resetLocationSelections() {
            this.ifh_selectedProvince = null;
            this.ira_selectedAmphur = null;
            this.ira_selectedTambon = null;

            this.error_latlon_country = false;
            this.error_latlon_land = false;
            this.error_latlon_P = false;
            this.error_latlon_A = false;
            this.error_latlon_T = false;
        },
        handleInputLatLon() {
            this.error_ifh_lat = false; // Clear the error flag when typing
            this.error_ifh_lat_dot = false; // Clear the error flag for multiple dots
            this.error_ifh_lon = false;
            this.error_ifh_lon_dot = false;
        },
        handleInput() {
            this.inputMap_latlon(); // Call your existing inputMap_latlon function
            this.handleInputLatLon(); // Call the handleInputLatLon function
        },
        async inputMap_PAT_latlon() {
            // console.log("<<<<<<<<<<<<<<<MMMMMMMMMMMMMM>>>>>>>>>>>>>>>")
            //   console.log("this.ifh_selectedProvince",this.ifh_selectedProvince)
            //   console.log("this.ira_selectedAmphur",this.ira_selectedAmphur)
            //   console.log("this.ira_selectedTambon",this.ira_selectedTambon)

            const url = 'https://service.deemap.com/service/gismis/boundary/geojson';

            let nnP = '';

            if (this.ifh_selectedProvince) {
                this.sP.push(this.ifh_selectedProvince.province_name);
                nnP = this.sP.length - 2;
            }

            let nnA = '';
            if (this.ira_selectedAmphur) {
                this.sA.push(this.ira_selectedAmphur.amphur_name);
                nnA = this.sA.length - 2;
            }

            // if (this.ifh_FireStationSelected) {
            //   await this.axios.post(url,{
            // 				"key":"78e731027d8fd50ed642340b7c9a63b3",
            // 				"topic": "fireStation",
            // 				"type":"point",
            // 				"name":this.ifh_FireStationSelected.fs_tname
            // 			})
            // 			.then((response) => {
            // 				let getData = response.data.data

            // 				const lon = getData.features[0].geometry.coordinates[0];
            // 				const lat = getData.features[0].geometry.coordinates[1];

            //         // const PAT_Tambon = this.ifh_FireStationSelected.tambon_name
            // 				// const PAT_Amphoe = this.ifh_FireStationSelected.amphur_name
            // 				// const PAT_province = this.ifh_FireStationSelected.province_name

            //         // console.log("PAT_Tambon",PAT_Tambon)
            //         // console.log("PAT_Amphoe",PAT_Amphoe)
            //         // console.log("PAT_province",PAT_province)
            //         this.ifh_lat = lat
            //         this.ifh_lon = lon

            //         this.error_latlon_P = false
            //         this.error_latlon_A = false
            //         this.error_latlon_T = false

            // 			})
            // }else
            if (this.ifh_selectedProvince == null) {
                this.ifh_lat = '';
                this.ifh_lon = '';

                this.error_latlon_country = false;
                this.error_latlon_P = false;
                this.error_latlon_A = false;
                this.error_latlon_T = false;
            } else if (this.ira_selectedAmphur == null) {
                await this.axios
                    .post(url, {
                        key: '78e731027d8fd50ed642340b7c9a63b3',
                        topic: 'province',
                        type: 'point',
                        id: this.ifh_selectedProvince.province_id
                    })
                    .then((response) => {
                        let getData = response.data.data;

                        const lon = getData.features[0].geometry.coordinates[0];
                        const lat = getData.features[0].geometry.coordinates[1];

                        this.ifh_lat = lat.toFixed(6);
                        this.ifh_lon = lon.toFixed(6);

                        this.error_latlon_country = false;
                        this.error_latlon_P = false;
                        this.error_latlon_A = false;
                        this.error_latlon_T = false;
                    });
            } else if (this.sP[nnP] !== this.ifh_selectedProvince.province_name) {
                await this.axios
                    .post(url, {
                        key: '78e731027d8fd50ed642340b7c9a63b3',
                        topic: 'province',
                        type: 'point',
                        id: this.ifh_selectedProvince.province_id
                    })
                    .then((response) => {
                        let getData = response.data.data;

                        const lon = getData.features[0].geometry.coordinates[0];
                        const lat = getData.features[0].geometry.coordinates[1];

                        this.ifh_lat = lat.toFixed(6);
                        this.ifh_lon = lon.toFixed(6);

                        this.error_latlon_country = false;
                        this.error_latlon_P = false;
                        this.error_latlon_A = false;
                        this.error_latlon_T = false;
                    });
            } else if (this.sA[nnA] !== this.ira_selectedAmphur.amphur_name) {
                await this.axios
                    .post(url, {
                        key: '78e731027d8fd50ed642340b7c9a63b3',
                        topic: 'amphoe',
                        type: 'point',
                        id: this.ira_selectedAmphur.amphur_id
                    })
                    .then((response) => {
                        let getData = response.data.data;

                        const lon = getData.features[0].geometry.coordinates[0];
                        const lat = getData.features[0].geometry.coordinates[1];

                        this.ifh_lat = lat.toFixed(6);
                        this.ifh_lon = lon.toFixed(6);

                        this.error_latlon_country = false;
                        this.error_latlon_P = false;
                        this.error_latlon_A = false;
                        this.error_latlon_T = false;
                    });
            } else {
                // if (this.ifh_FireStationSelected) {
                // 	await this.axios.post(url,{
                // 			"key":"78e731027d8fd50ed642340b7c9a63b3",
                // 			"topic": "fireStation",
                // 			"type":"point",
                // 			"name":this.ifh_FireStationSelected.fs_tname
                // 		})
                // 		.then((response) => {
                // 			let getData = response.data.data

                // 			const lon = getData.features[0].geometry.coordinates[0];
                // 			const lat = getData.features[0].geometry.coordinates[1];

                //       this.ifh_lat = lat
                //       this.ifh_lon = lon

                //       this.error_latlon_P = false
                //       this.error_latlon_A = false
                //       this.error_latlon_T = false

                // 		})
                // }else
                if (this.ira_selectedTambon) {
                    await this.axios
                        .post(url, {
                            key: '78e731027d8fd50ed642340b7c9a63b3',
                            topic: 'tambon',
                            type: 'point',
                            id: this.ira_selectedTambon.tambon_id
                        })
                        .then((response) => {
                            let getData = response.data.data;

                            const lon = getData.features[0].geometry.coordinates[0];
                            const lat = getData.features[0].geometry.coordinates[1];

                            this.ifh_lat = lat.toFixed(6);
                            this.ifh_lon = lon.toFixed(6);

                            this.error_latlon_country = false;
                            this.error_latlon_P = false;
                            this.error_latlon_A = false;
                            this.error_latlon_T = false;
                        });
                } else if (this.ira_selectedAmphur) {
                    await this.axios
                        .post(url, {
                            key: '78e731027d8fd50ed642340b7c9a63b3',
                            topic: 'amphoe',
                            type: 'point',
                            id: this.ira_selectedAmphur.amphur_id
                        })
                        .then((response) => {
                            let getData = response.data.data;

                            const lon = getData.features[0].geometry.coordinates[0];
                            const lat = getData.features[0].geometry.coordinates[1];

                            this.ifh_lat = lat.toFixed(6);
                            this.ifh_lon = lon.toFixed(6);

                            this.error_latlon_country = false;
                            this.error_latlon_P = false;
                            this.error_latlon_A = false;
                            this.error_latlon_T = false;
                        });
                } else if (this.ifh_selectedProvince) {
                    await this.axios
                        .post(url, {
                            key: '78e731027d8fd50ed642340b7c9a63b3',
                            topic: 'province',
                            type: 'point',
                            id: this.ifh_selectedProvince.province_id
                        })
                        .then((response) => {
                            let getData = response.data.data;

                            const lon = getData.features[0].geometry.coordinates[0];
                            const lat = getData.features[0].geometry.coordinates[1];

                            this.ifh_lat = lat.toFixed(6);
                            this.ifh_lon = lon.toFixed(6);

                            this.error_latlon_country = false;
                            this.error_latlon_P = false;
                            this.error_latlon_A = false;
                            this.error_latlon_T = false;
                        });
                } else {
                    this.ifh_lat = '';
                    this.ifh_lon = '';
                }
            }
        },
        //  Doe เพิ่มหมุด map V.2 6/9  จบ-->

        async confirmDelete() {
            if (!this.checkToken()) {
                return;
            }

            // console.log('this.checkToken() = ', this.checkToken());

            const userId = this.getUsername();

            this.displayConfirmation = false;
            await this.axios
                .post(`${this.$url_service}/initial/extinguisher?user=${userId}`, {
                    body: {
                        topic: 'delete-extinguisher',
                        id: this.temp,
                        userData: this.getUser()
                    }
                })
                .then(() =>
                    // this.initialData()
                    // this.searchFireHydrant()
                    this.searchFireHydrant()
                );
            this.$fire({
                type: 'success',
                title: 'ลบข้อมูลสำเร็จ',
                text: 'ข้อมูลถังดับเพลิง',
                timer: 3000,
                confirmButtonColor: '#28B463'
            });
        },

        async saveData() {
            if (!this.checkToken()) {
                return;
            }

            // console.log('this.checkToken() = ', this.checkToken());

            //Check null value

            //   if (this.ifh_pipe_size == "") {
            //     this.error_ifh_pipe_size = true;
            // }else if (this.ifh_lat == "") {
            //     this.error_ifh_lat = true;
            // }else if (this.ifh_lon == "") {
            //     this.error_ifh_lon = true;
            // } else {

            //ตัวแดงทั้งหมด
            if (
                this.iex_extinguisher_size == '' ||
                this.ifh_selectedProvince == null ||
                this.ifh_selectedProvince == 'null' ||
                this.iex_extinguisher_size === '' ||
                this.iex_extinguisher_type === '' ||
                this.iex_extinguisher_status === '' ||
                this.iex_place_name === '' ||
                // this.iex_location_type === '' ||
                this.ira_selectedAmphur == null ||
                this.ira_selectedAmphur == 'null' ||
                this.ira_selectedTambon == null ||
                this.ira_selectedTambon == 'null' ||
                this.ifh_lat == '' ||
                !/^13\.\d+$/.test(this.ifh_lat) ||
                this.ifh_lon == '' ||
                !/^100\.\d+$/.test(this.ifh_lon) ||
                this.organizeTypeOptions == null ||
                this.organizeTypeOptions == 'null'

                // || this.ifh_FireStationSelected == null ||
                // this.ifh_FireStationSelected == 'null'
            ) {
                if (this.iex_extinguisher_size == '') {
                    this.error_iex_extinguisher_size = true;
                }
                if (this.iex_extinguisher_type == '') {
                    this.error_iex_extinguisher_type = true;
                }
                // if (this.iex_extinguisher_status == '') {
                //     this.error_iex_extinguisher_status = true;
                // }
                if (this.iex_place_name == '') {
                    this.error_iex_place_name = true;
                }
                if (this.ifh_selectedProvince == null) {
                    this.error_ifh_selectedProvince = true;
                }
                if (this.ifh_selectedProvince == 'null') {
                    this.error_ifh_selectedProvince = true;
                }
                if (this.ira_selectedAmphur == null) {
                    this.error_ira_selectedAmphur = true;
                }
                if (this.ira_selectedAmphur == 'null') {
                    this.error_ira_selectedAmphur = true;
                }
                if (this.ira_selectedTambon == null) {
                    this.error_ira_selectedTambon = true;
                }
                if (this.ira_selectedTambon == 'null') {
                    this.error_ira_selectedTambon = true;
                }
                if (this.ifh_lat == '') {
                    this.error_ifh_lat_dot = false;
                    this.error_ifh_lat = true;
                } else if (!/^13\.\d+$/.test(this.ifh_lat)) {
                    this.error_ifh_lat = false;
                    this.error_ifh_lat_dot = true;
                }
                if (this.ifh_lon == '') {
                    this.error_ifh_lon_dot = false;
                    this.error_ifh_lon = true;
                } else if (!/^100\.\d+$/.test(this.ifh_lon)) {
                    this.error_ifh_lon = false;
                    this.error_ifh_lon_dot = true;
                }

                // if (this.ifh_FireStationSelected == null) {
                //     this.error_ifh_FireStationSelected = true;
                // }
                // if (this.ifh_FireStationSelected == 'null') {
                //     this.error_ifh_FireStationSelected = true;
                // }
                if (this.organizeTypeOptions == null) {
                    this.error_organizeTypeOptions = true;
                }
                if (this.organizeTypeOptions == 'null') {
                    this.error_organizeTypeOptions = true;
                }
            } else {
                if (this.selectedData == '') {
                    // const lat = this.ifh_lat.trim();
                    // const lon = this.ifh_lon.trim();

                    // const formattedLat = Number(lat).toFixed(6).padEnd(9, '0');
                    // const formattedLon = Number(lon).toFixed(6).padEnd(9, '0');
                    // console.log('this.selectedData =', this.selectedData);
                    // console.log('add-firehydran');
                    // โหลดเพิ่มแก้ไข 4/8
                    this.loadingCreate = true;
                    // โหลดเพิ่มแก้ไข 4/8 จบ
                    // console.log(this.$refs.io_image.innerText)
                    // console.log(this.$refs.io_image.innerText)
                    // console.log(this.imageName)
                    // console.log(formattedLat, formattedLon)
                    // console.log(this.ifh_selectedProvince, this.ira_selectedAmphur, this.ira_selectedTambon)
                    if (this.ifh_FireStationSelected?.fs_tname) {
                        const FireStation = this.FireStationOptions_Form.find((x) => x.fs_tname == this.ifh_FireStationSelected.fs_tname);
                        if (FireStation) {
                            this.ifh_FireStationSelected = FireStation;
                        }
                    }

                    // console.log('getUser' + this.getUser());
                    // console.log('userOrg' + this.getUserOrganize());

                    const userId = this.getUsername();
                    // console.log('userId', userId);
                    await this.axios
                        .post(`${this.$url_service}/initial/extinguisher?user=${userId}`, {
                            body: {
                                topic: 'add-extinguisher',
                                userOrg: this.getUserOrganize(),
                                userData: this.getUser(),
                                user_organize: this.ifh_FireStationSelected || null,
                                system_id: this.organizeTypeOptions.system_id || null,
                                place_name: this.iex_place_name,
                                type: this.iex_extinguisher_type,
                                status: this.iex_extinguisher_status,
                                location_type: this.iex_location_type,
                                extinguisher_size: this.iex_extinguisher === '' ? '' : this.iex_extinguisher_size,
                                latch_lock: this.iex_latch_lock === '' ? '' : this.iex_latch_lock.name,
                                controller: this.iex_controller === '' ? '' : this.iex_controller.name,
                                pressure_gauge: this.iex_pressure_gauge === '' ? '' : this.iex_pressure_gauge.name,
                                line_spray: this.iex_line_spray === '' ? '' : this.iex_line_spray.name,
                                chassis: this.iex_chassis === '' ? '' : this.iex_chassis.name,
                                province: this.ifh_selectedProvince.province_name,
                                amphur: this.ira_selectedAmphur.amphur_name,
                                tambon: this.ira_selectedTambon.tambon_name,
                                details: this.iex_details === '' ? '' : this.iex_details,
                                lat: this.ifh_lat,
                                lon: this.ifh_lon,
                                image: this.$refs.io_image.innerText === '' ? '-' : this.$refs.io_image.innerText,
                                date_expire: this.date_expire_form || null,
                                code: this.iex_extinguisher_code,
                                extinguisher_status: this.statusOrganize,
                                community_name: this.ifh_community_name !== null ? this.ifh_community_name.community_name : '',
                                create_by: userId,
                                edit_by: userId
                            }
                        })

                        .then((response) => {
                            if (response) {
                                this.loadingCreate = false;
                                // โหลดเพิ่มแก้ไข 5/8 จบ
                                this.tempFor_displayConfirmationCloseModal = 'add';
                                this.FireHydrantModal = false;
                                this.$fire({
                                    type: 'success',
                                    title: 'เพิ่มข้อมูลสำเร็จ',
                                    text: 'ข้อมูลถังดับเพลิง',
                                    timer: 3000,
                                    confirmButtonColor: '#28B463'
                                });
                            }
                            // (this.check_duplicate = response.data.message)
                            // (this.initialData());
                            // this.searchFireHydrant()
                            this.searchFireHydrant();
                        });
                    // โหลดเพิ่มแก้ไข 5/8
                } else {
                    // console.log('this.selectedData =', this.selectedData);
                    if (this.$refs.io_image.innerText == '') {
                        this.$refs.io_image.innerText = this.url;
                    } else {
                        this.$refs.io_image.innerText = this.$refs.io_image.innerText;
                    }

                    if (
                        this.ifh_FireStationSelected &&
                        (this.ifh_FireStationSelected.fs_tname == null || this.ifh_FireStationSelected.fs_tname == 'null')
                    ) {
                        this.error_ifh_FireStationSelected = true;
                    } else {
                        // โหลดเพิ่มแก้ไข 6/8 จบ
                        this.loadingCreate = true;
                        // โหลดเพิ่มแก้ไข 6/8 จบ
                        // const lat = this.ifh_lat.trim();
                        // const lon = this.ifh_lon.trim();
                        // console.log(this.$refs.io_image.innerText === "")
                        // const formattedLat = Number(lat).toFixed(6).padEnd(9, "0");
                        // const formattedLon = Number(lon).toFixed(6).padEnd(10, "0");
                        // console.log(this.$refs.io_image.innerText)

                        // console.log('getUser' + this.getUser());
                        const userOrg = this.getUserOrganize(); //เช็คสิทธิ์
                        const userId = this.getUsername();

                        await this.axios
                            .post(`${this.$url_service}/initial/extinguisher?user=${userId}`, {
                                body: {
                                    topic: 'edit-extinguisher',
                                    id: this.temp,
                                    userData: this.getUser(),
                                    userOrg: userOrg,
                                    user_organize: this.ifh_FireStationSelected,
                                    system_id: this.organizeTypeOptions.system_id,
                                    place_name: this.iex_place_name,
                                    type: this.iex_extinguisher_type,
                                    status: this.iex_extinguisher_status,
                                    location_type: this.iex_location_type,
                                    extinguisher_size: this.iex_extinguisher === '' ? '' : this.iex_extinguisher_size,
                                    latch_lock: this.iex_latch_lock === '' ? '' : this.iex_latch_lock.name,
                                    controller: this.iex_controller === '' ? '' : this.iex_controller.name,
                                    pressure_gauge: this.iex_pressure_gauge === '' ? '' : this.iex_pressure_gauge.name,
                                    line_spray: this.iex_line_spray === '' ? '' : this.iex_line_spray.name,
                                    chassis: this.iex_chassis === '' ? '' : this.iex_chassis.name,
                                    province: this.ifh_selectedProvince.province_name,
                                    amphur: this.ira_selectedAmphur.amphur_name,
                                    tambon: this.ira_selectedTambon.tambon_name,
                                    details: this.iex_details === '' ? '' : this.iex_details,
                                    lat: this.ifh_lat,
                                    lon: this.ifh_lon,
                                    image: this.$refs.io_image.innerText === '' ? '-' : this.$refs.io_image.innerText,
                                    ...(this.date_expire_form !== this.selectedData.date_expire ? { date_expire: this.date_expire_form } : {}),
                                    // date_expire: this.date_expire_form || null,
                                    code: this.iex_extinguisher_code,
                                    extinguisher_status: this.statusOrganize,
                                    community_name: this.ifh_community_name !== null ? this.ifh_community_name.community_name : '',
                                    edit_by: userId
                                }
                            })
                            .then((res) => {
                                if (res)
                                    // this.initialData()
                                    // this.searchFireHydrant()

                                    this.loadingCreate = false;
                                // โหลดเพิ่มแก้ไข 7/8 จบ
                                this.$fire({
                                    type: 'success',
                                    title: 'แก้ไขข้อมูลสำเร็จ',
                                    text: 'ข้อมูลถังดับเพลิง',
                                    timer: 3000,
                                    confirmButtonColor: '#28B463'
                                });
                                // console.log("Edit data", this.ifh_location);
                                this.FireHydrantModal = false;
                                this.searchFireHydrant();
                            });
                        // โหลดเพิ่มแก้ไข 7/8 จบ
                    }
                }
            }
        },

        async editData(data) {
            if (!this.checkToken()) {
                return;
            }

            this.temp = data;

            this.selectedData = 'editing';

            // console.log('this.checkToken() = ', this.checkToken());

            // console.log('data =', data);
            this.header = this.$i18n.t('iex_modal_title_edit');
            await this.axios
                .post(`${this.$url_service}/initial/extinguisher`, {
                    body: {
                        topic: 'showone-extinguisher',
                        id: data,
                        userData: this.getUser()
                    }
                })
                .then((response) => {
                    if (!response.data?.data) {
                        throw new Error('ไม่สามารถโหลดข้อมูลถังดับเพลิงได้');
                    }
                    // console.log('response.data.data', response.data.data), (this.selectedData = response.data.data);

                    this.selectedData = response.data.data;
                    if (
                        !response.data.data.community_name ||
                        response.data.data.community_name == null ||
                        response.data.data.community_name == '' ||
                        response.data.data.community_name == 'null' ||
                        response.data.data.community_name == 'undefined'
                    ) {
                        this.ifh_community_name = null;
                    } else {
                        this.ifh_community_name = {
                            community_id: response.data.data.community_id || '',
                            community_name: response.data.data.community_name
                        };
                    }
                    // console.log('this.selectedData', this.selectedData),
                    (this.iex_extinguisher_size = response.data.data.fire_extinguisher_size),
                        (this.iex_extinguisher_type = response.data.data.type),
                        (this.iex_extinguisher_status = response.data.data.status),
                        (this.iex_place_name = response.data.data.place_name),
                        (this.iex_location_type = response.data.data.location_type),
                        (this.ifh_lat = response.data.data.lat),
                        (this.ifh_lon = response.data.data.lon);

                    //เพิ่มที่ขาด
                    // (this.iex_chassis.id = response.data.data.chassis == "TRUE" ? '1' : '2');
                    // (this.iex_chassis.name = response.data.data.chassis);
                    // (this.iex_line_spray.id = response.data.data.line_spray == "TRUE" ? '1' : '2');
                    // (this.iex_line_spray.name = response.data.data.line_spray);
                    // (this.iex_pressure_gauge.id = response.data.data.pressure_gauge == "TRUE" ? '1' : '2');
                    // (this.iex_pressure_gauge.name = response.data.data.pressure_gauge);
                    // (this.iex_controller.id = response.data.data.joystick == "TRUE" ? '1' : '2');
                    // (this.iex_controller.name = response.data.data.joystick);
                    // (this.iex_latch_lock.id = response.data.data.latch_lock == "TRUE" ? '1' : '2');
                    // (this.iex_latch_lock.name = response.data.data.latch_lock);
                    //แบบเรียกฟังก์ชั่น
                    this.updateProperty('iex_chassis', response.data.data.chassis);
                    this.updateProperty('iex_line_spray', response.data.data.line_spray);
                    this.updateProperty('iex_pressure_gauge', response.data.data.pressure_gauge);
                    this.updateProperty('iex_controller', response.data.data.joystick);
                    this.updateProperty('iex_latch_lock', response.data.data.latch_lock);

                    (this.ifh_selectedProvince = {
                        province_id: response.data.data.province_id || '',
                        province_name: response.data.data.province
                    }),
                        (this.ira_selectedAmphur = {
                            amphur_id: response.data.data.amphur_id || '',
                            amphur_name: response.data.data.country
                        }),
                        (this.ira_selectedTambon = {
                            tambon_id: response.data.data.tambon_id || '',
                            tambon_name: response.data.data.subdistrict
                        }),
                        (this.ifh_FireStationSelected = {
                            fs_tname: response.data.data.fire_station
                        });
                    this.iex_details = response.data.data.details;

                    this.url = this.pickRecordImageRaw(response.data.data, 'image_cloud');

                    const dateCreateForm =
                        response.data.data.date_created == null
                            ? '-'
                            : new Date(response.data.data.date_created).toLocaleDateString('th-TH', {
                                  year: 'numeric',
                                  month: 'long',
                                  day: 'numeric'
                              });
                    this.date_create_form = dateCreateForm;

                    const dateUpdateForm =
                        response.data.data.date_update == null
                            ? '-'
                            : new Date(response.data.data.date_update).toLocaleDateString('th-TH', {
                                  year: 'numeric',
                                  month: 'long',
                                  day: 'numeric'
                              });
                    this.date_update_form = dateUpdateForm;

                    // this.date_expire_form =
                    //     response.data.data.date_expire == null ? '-' : new Date(response.data.data.date_expire).toISOString().substring(0, 10);

                    this.date_expire_form =
                        response.data.data.date_expire == null ? '-' : new Date(response.data.data.date_expire).toLocaleDateString('en-CA');

                    this.originalExpireDate = response.data.data.date_expire;

                    this.iex_extinguisher_code = response.data.data.code == null ? '' : response.data.data.code;

                    // Doe เพิ่มหมุด map V.2 7/9
                    if (this.ifh_lat !== '' && this.ifh_lat !== null && this.ifh_lon !== '' && this.ifh_lon !== null) {
                        this.inputMap_latlon();
                    } else {
                        this.inputMap_PAT_latlon();
                    }
                    // Doe เพิ่มหมุด map V.2 7/9  จบ

                    this.FireHydrantModal = true;
                    setTimeout(() => {
                        const FireStation = this.FireStationOptions_Form.find((x) => x.fs_tname == response.data.data.fire_station);
                        if (FireStation) {
                            this.ifh_FireStationSelected = FireStation;
                        }

                        const systemId = this.organizeTypeOptions_Form.find((x) => x.system_id == response.data.data.system_id);
                        if (systemId) {
                            this.organizeTypeOptions = systemId;
                        }

                        if (response.data.data.province == null) {
                            this.ifh_selectedProvince = null;
                            this.iex_place_name = '';
                            this.iex_extinguisher_size = '';
                        }
                        // this.iex_chassis.name = response.data.data.chassis;
                    }, 1000);
                })
                .catch((error) => {
                    console.error('showone-extinguisher error:', error);
                    this.$fire({
                        type: 'error',
                        title: 'ไม่สามารถเปิดหน้าแก้ไขได้',
                        text: error.response?.data?.message || error.message || 'กรุณาลองเข้าสู่ระบบใหม่อีกครั้ง',
                        confirmButtonColor: '#d33'
                    });
                });

            this.calStatus();
        },

        updateProperty(property, value) {
            this[property].id = value == 'TRUE' ? '1' : '2';
            this[property].name = value ? value : 'TRUE';
        },

        clearData() {
            this.tempFor_displayConfirmationCloseModal = '';
            this.dropdownClearFilerValue += 1;
            //Edit data
            if (this.selectedData != '') {
                this.header = this.$i18n.t('iex_modal_title_add');
                this.temp = null;
                this.displayConfirmation = false;
                this.selectedData = '';
                this.FireHydrantModal = false;
                this.i = 0;
                this.setDefault();

                //Add data
            } else {
                this.temp = null;
                this.displayConfirmation = false;
                this.setDefault();
            }
        },

        setDefault() {
            this.tempFor_displayConfirmationCloseModal = '';
            this.iex_extinguisher_size = '';
            this.ifh_soi_name = '';
            this.ifh_road_name = '';
            this.ifh_community_name = '';
            this.ifh_lat = '';
            this.ifh_lon = '';
            this.error_iex_extinguisher_size = false;
            this.error_iex_extinguisher_type = false;
            // this.error_iex_extinguisher_status = false;
            this.error_iex_place_name = false;
            this.error_ifh_selectedProvince = false;
            this.error_ira_selectedAmphur = false;
            this.error_ira_selectedTambon = false;
            this.error_ifh_status = false;
            this.error_ifh_lat = false;
            this.error_ifh_lat_dot = false;
            this.error_ifh_lon = false;
            this.error_ifh_lon_dot = false;
            this.ifh_selectedProvince = null;
            this.ifh_FireStationSelected = null;
            this.organizeTypeOptions = null;
            this.error_ifh_FireStationSelected = false;
            this.error_organizeTypeOptions = false;
            this.ifs_status = null;
            this.ifs_inspec_details = '';
            this.iex_details = '';
            this.iex_extinguisher_type = '';
            this.iex_extinguisher_status = '';
            this.iex_place_name = '';
            this.iex_location_type = '';
            this.ifh_location = '';

            this.error_latlon_country = false;
            this.error_latlon_land = false;
            this.error_latlon_P = false;
            this.error_latlon_A = false;
            this.error_latlon_T = false;

            this.url = null;
            this.iex_extinguisher_code = '';
            document.getElementById('fireHydrant_uploadImageFile').value = '';

            this.iex_latch_lock = { id: '1', name: 'TRUE' };
            this.iex_controller = { id: '1', name: 'TRUE' };
            this.iex_pressure_gauge = { id: '1', name: 'TRUE' };
            this.iex_line_spray = { id: '1', name: 'TRUE' };
            this.iex_chassis = { id: '1', name: 'TRUE' };
            this.statusOrganize = 'ปกติ';
            // this.date_create_form = ""
            // this.date_update_form = ""
        },

        async clearSearchField() {
            this.selectedProvince = null;
            this.extinguisher_size = '';
            this.type = '';
            this.place_name = '';
            this.location_type = '';
            this.FireStationSelected = null;
            this.status = null;
            this.inspec_details = '';

            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            this.text_Footer = false;

            this.dropdownClearFilerValue += 1;
            // Doe ค้นหา
            this.filter = '';
            this.cloneTable = [];
            this.FireHydrant_Table = [];

            // this.initialData()
            this.paramsQuery = '';
            this.ife_extinguisher_code = '';
            this.isSearchMode = false;
            this.resetTableSearchPagination();
        },
        // Doe โหลด โทรศัพท์
        async MobileClearSearchField() {
            // console.log("this.ms3333",this.ms)
            if (this.ms == true) {
                this.clearSearchField();
            } else {
                // console.log("25")
                this.selectedProvince = null;
                this.pipe_size = '';
                this.soi_name = '';
                this.road_name = '';
                this.community_name = '';
                this.FireStationSelected = null;
                this.status = null;
                this.inspec_details = '';

                this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
                this.text_Footer = false;

                this.dropdownClearFilerValue += 1;
                this.filter = '';
                this.cloneTable = [];
                this.FireHydrant_Table = [];
                this.paramsQuery = '';
                this.ife_extinguisher_code = '';
                this.isSearchMode = false;
                this.resetTableSearchPagination();
            }
        },
        // Doe โหลด โทรศัพท์
        // Doe :   เพิ่ม มุดmap 4/4
        sendM(ifh_lat, ifh_lon) {
            let lat = ifh_lat;
            let lon = ifh_lon;
            this.latlon = { lat, lon };
            // console.log("send ",this.latlon)
        },
        sendM_PAT(tambon, amphur, province, FireStationSelected) {
            if (FireStationSelected) {
                this.FSS = FireStationSelected;
            } else {
                this.FSS = {};
            }

            if (tambon) {
                this.PAT = tambon;
            } else if (amphur) {
                this.PAT = amphur;
            } else if (province) {
                this.PAT = province;
            } else {
                this.PAT = {};
            }
        },

        //  Doe เพิ่มหมุด map V.2 8/9  -->
        async receiveM_PAT(data) {
            try {
                const element = data.ADMIN_CODE;
                const country_ID = `${element[0]}${element[1]}`;
                const land_ID = `${element[2]}${element[3]}`;
                const province_ID = `${element[4]}${element[5]}`;
                const amphur_ID = `${element[4]}${element[5]}${element[6]}${element[7]}`;
                const tambon_ID = `${element[4]}${element[5]}${element[6]}${element[7]}${element[8]}${element[9]}`;

                if (country_ID == '66' && land_ID !== '00') {
                    this.locationLoading = true; // Show loading indicator

                    // Reset all selections first
                    this.ifh_selectedProvince = null;
                    this.ira_selectedAmphur = null;
                    this.ira_selectedTambon = null;

                    await this.$nextTick();

                    // Load all required options first
                    // Load amphur options for this province
                    const amphurResponse = await this.axios.post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-amphur',
                            province_id: province_ID
                        }
                    });
                    this.amphurOptions = amphurResponse.data.data;
                    this.ira_isDisabledAmphur = 0;

                    // Load tambon options for this amphur
                    const tambonResponse = await this.axios.post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-tambon',
                            amphur_id: amphur_ID
                        }
                    });
                    this.tambonOptions = tambonResponse.data.data;
                    this.ira_isDisabledTambon = 0;

                    // Now set all values in correct order
                    this.ifh_selectedProvince = {
                        province_name: data.provinceName,
                        province_id: province_ID
                    };

                    await this.$nextTick(); // Allow UI to update

                    this.ira_selectedAmphur = {
                        amphur_name: data.amphurName,
                        amphur_id: amphur_ID
                    };

                    await this.$nextTick(); // Allow UI to update

                    this.ira_selectedTambon = {
                        tambon_name: data.tambonName,
                        tambon_id: tambon_ID
                    };

                    // Reset all error flags
                    this.error_latlon_country = false;
                    this.error_latlon_land = false;
                    this.error_latlon_P = false;
                    this.error_latlon_A = false;
                    this.error_latlon_T = false;

                    // Update community options based on the selected amphur
                    if (this.ira_selectedAmphur) {
                        await this.updateCommunityOptions(data.amphurName);
                    }

                    // Update fire station options
                    await this.check_Fire_Form_search(this.ira_selectedTambon, this.ira_selectedAmphur, this.ifh_selectedProvince, 'form', true);
                } else {
                    if (country_ID !== '66') {
                        this.error_latlon_country = true;
                    } else {
                        this.error_latlon_country = false;
                    }

                    if (data.provinceName == null || data.provinceName == 'null' || data.provinceName == '' || data.provinceName == ' ') {
                        this.error_latlon_P = true;
                    } else {
                        this.error_latlon_P = false;
                    }
                    if (data.amphurName == null || data.amphurName == 'null' || data.amphurName == '' || data.amphurName == ' ') {
                        this.error_latlon_A = true;
                    } else {
                        this.error_latlon_A = false;
                    }
                    if (data.tambonName == null || data.tambonName == 'null' || data.tambonName == '' || data.tambonName == ' ') {
                        this.error_latlon_T = true;
                    } else {
                        this.error_latlon_T = false;
                    }

                    this.ifh_selectedProvince = null;
                    this.ira_selectedAmphur = null;
                    this.ira_selectedTambon = null;
                }
            } catch (error) {
                console.error('Error in receiveM_PAT:', error);
                this.resetLocationSelections();
            } finally {
                this.locationLoading = false; // Hide loading indicator
            }
        },

        //  Doe เพิ่มหมุด map V.2 8/9  จบ-->

        // Doe :   เพิ่ม มุดmap 4/4 จบ
        alertDisplay(temp) {
            this.$fire({
                title: 'ยืนยันการลบข้อมูล',
                text: 'คุณต้องการลบข้อมูลนี้ใช่หรือไม่ ?',

                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ตกลง',
                cancelButtonText: 'ยกเลิก'
            }).then((result) => {
                // console.log(temp)
                if (result.value) {
                    // console.log(temp)
                    this.confirmDelete(temp);
                }
            });
        },

        // Doe PDF เลือกได้  5/5
        EditPDF() {
            this.displayEditPDF = true;
            this.columnsSelectorDialog = this.columnsSelector;
        },
        SaveEditPDF() {
            if (this.columnsSelectorDialog.length <= 4) {
                this.PDF_minCellWidthVer = 120;
                this.PDF_FontHeaderVer = 13;
                this.PDF_FontBodyVer = 11;

                this.PDF_BodySizeSelect = {
                    index: { cellWidth: 35 }
                };

                this.PDF_minCellWidthHor = 120;
                this.PDF_FontHeaderHor = 15;
                this.PDF_FontBodyHor = 12;

                this.PDF_BodySizeHorSelect = {
                    index: { cellWidth: 35 }
                };
            } else if (this.columnsSelectorDialog.length <= 6) {
                this.PDF_minCellWidthVer = 50;
                this.PDF_FontHeaderVer = 13;
                this.PDF_FontBodyVer = 11;

                this.PDF_BodySizeSelect = {
                    index: { cellWidth: 35 },
                    pipe_size: { cellWidth: 93 },
                    fire_station: { cellWidth: 80 }
                };

                this.PDF_minCellWidthHor = 80;
                this.PDF_FontHeaderHor = 15;
                this.PDF_FontBodyHor = 12;

                this.PDF_BodySizeHorSelect = {
                    index: { cellWidth: 35 },
                    pipe_size: { cellWidth: 80 }
                };
            } else if (this.columnsSelectorDialog.length <= 15) {
                this.PDF_minCellWidthVer = 40;
                this.PDF_FontHeaderVer = 7;
                this.PDF_FontBodyVer = 5;
                this.PDF_BodySizeSelect = {
                    index: { cellWidth: 21 },
                    pipe_size: { cellWidth: 35 },
                    fire_station: { cellWidth: 53 },
                    // inspec_details:{cellWidth:40},
                    status: { cellWidth: 28 },
                    event_latPDF: { cellWidth: 28 },
                    event_lonPDF: { cellWidth: 28 }
                };

                this.PDF_minCellWidthHor = 50;
                this.PDF_FontHeaderHor = 10;
                this.PDF_FontBodyHor = 8;

                this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor;
            } else {
                this.PDF_minCellWidthVer = 40;
                this.PDF_FontHeaderVer = 7;
                this.PDF_FontBodyVer = 5;
                this.PDF_BodySizeSelect = this.PDF_BodySize;
                this.PDF_minCellWidthHor = 50;
                this.PDF_FontHeaderHor = 10;
                this.PDF_FontBodyHor = 8;

                this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor;
            }

            if (this.columnsSelectorDialog.length == 0) {
                this.columns_index = false;
                this.columns_pipe_size = false;
                this.columns_img = false;
                this.columns_soi_name = false;
                this.columns_road_name = false;
                this.columns_community_name = false;
                this.columns_fire_station = false;
                this.columns_location = false;
                this.columns_tambon_name = false;
                this.columns_amphur_name = false;
                this.columns_province_name = false;
                this.columns_event_lat = false;
                this.columns_event_lon = false;
                this.columns_status = false;
                this.columns_status_organize = false;
                this.columns_inspec_details = false;

                this.columns_date_create = false;
                this.columns_date_update = false;

                this.columns_disabled = false;
            } else {
                this.columns_disabled = true;

                this.GetData_ColumnsSearch = [];
                let getData = [];
                // ! จัดข้อมูล
                for (let index = 0; index < this.columnsSelectorDialog.length; index++) {
                    getData.push(this.columnsSelectorDialog[index].dataKey);
                }
                // let getData = this.GetData_ColumnsSearch;
                // console.log("getData",getData);

                // ! เช็คข้อมูล

                for (let index = 0; index < this.columnsSelectorDialog.length; index++) {
                    const element = this.columnsSelectorDialog[index].dataKey;

                    if (element == 'index') {
                        this.columns_index = true;
                    } else if (!getData.includes('index')) {
                        // console.log("getData.includes(index)",getData.includes("index"))
                        this.columns_index = false;
                    }

                    if (element == 'image_cloud') {
                        this.columns_img_cloud = true;
                    } else if (!getData.includes('image_cloud')) {
                        this.columns_img_cloud = false;
                    }

                    if (element == 'place_name') {
                        this.columns_place_name = true;
                    } else if (!getData.includes('place_name')) {
                        this.columns_place_name = false;
                    }

                    if (element == 'code') {
                        this.columns_code = true;
                    } else if (!getData.includes('code')) {
                        this.columns_code = false;
                    }

                    if (element == 'type') {
                        this.columns_type = true;
                    } else if (!getData.includes('type')) {
                        this.columns_type = false;
                    }

                    if (element == 'extinguisher_size') {
                        this.columns_extinguisher_size = true;
                    } else if (!getData.includes('extinguisher_size')) {
                        this.columns_extinguisher_size = false;
                    }

                    if (element == 'location_type') {
                        this.columns_location_type = true;
                    } else if (!getData.includes('location_type')) {
                        this.columns_location_type = false;
                    }

                    if (element == 'status') {
                        this.columns_status = true;
                    } else if (!getData.includes('status')) {
                        this.columns_status = false;
                    }

                    if (element == 'statusOrganize') {
                        this.columns_status_organize = true;
                    } else if (!getData.includes('status')) {
                        this.columns_status_organize = false;
                    }

                    if (element == 'country') {
                        this.columns_amphur = true;
                    } else if (!getData.includes('country')) {
                        this.columns_amphur = false;
                    }

                    if (element == 'subdistrict') {
                        this.columns_tambon = true;
                    } else if (!getData.includes('subdistrict')) {
                        this.columns_tambon = false;
                    }

                    if (element == 'community_name') {
                        this.columns_community_name = true;
                    } else if (!getData.includes('community_name')) {
                        this.columns_community_name = false;
                    }

                    if (element == 'lat') {
                        this.columns_lat = true;
                    } else if (!getData.includes('lat')) {
                        this.columns_lat = false;
                    }

                    if (element == 'lon') {
                        this.columns_lon = true;
                    } else if (!getData.includes('lon')) {
                        this.columns_lon = false;
                    }

                    if (element == 'fire_station') {
                        this.columns_fire_station = true;
                    } else if (!getData.includes('fire_station')) {
                        this.columns_fire_station = false;
                    }

                    if (element == 'details') {
                        this.columns_details = true;
                    } else if (!getData.includes('details')) {
                        this.columns_details = false;
                    }

                    if (element == 'date_expire') {
                        this.columns_date_expire = true;
                    } else if (!getData.includes('date_expire')) {
                        this.columns_date_expire = false;
                    }

                    if (element == 'date_created') {
                        this.columns_date_created = true;
                    } else if (!getData.includes('date_created')) {
                        this.columns_date_created = false;
                    }

                    if (element == 'date_update') {
                        this.columns_date_update = true;
                    } else if (!getData.includes('date_update')) {
                        this.columns_date_update = false;
                    }
                }
            }

            this.columnsSelector = this.columnsSelectorDialog;
            this.displayEditPDF = false;
            this.filter = '';
        },
        CloseEditPDF() {
            this.displayEditPDF = false;
        },
        ClearEditPDF() {
            this.columnsSelectorDialog = [];
        },
        SelectAllEditPDF() {
            this.columnsSelectorDialog = this.columns;
        },
        // Doe PDF เลือกได้  5/5 จบ

        calStatus() {
            if (
                this.iex_latch_lock.name == 'TRUE' &&
                this.iex_controller.name == 'TRUE' &&
                this.iex_pressure_gauge.name == 'TRUE' &&
                this.iex_line_spray.name == 'TRUE' &&
                this.iex_chassis.name == 'TRUE'
            ) {
                this.statusOrganize = 'ปกติ';
            } else {
                this.statusOrganize = 'ชำรุด';
            }
        },

        async genCodeId() {
            if (this.iex_extinguisher_type) {
                await this.axios
                    .post(`${this.$url_service}/initial/extinguisher`, {
                        body: {
                            topic: 'generatecode-extinguisher',
                            code: this.iex_extinguisher_type,
                            userData: this.getUser()
                        }
                    })
                    .then((response) => {
                        // console.log('response.data.data', response.data.newCode);
                        if (response.data.newCode) {
                            this.iex_extinguisher_code = response.data.newCode;
                        }
                    });
            }
        },
        //correct
        async genQrCode(code) {
            const fullLink = `${window.location.origin}/information/initial/Extinguisher?code=${code}`;
            this.code = code;
            // console.log('fullLink is :', fullLink);

            try {
                const qrDataURL = await QRCode.toDataURL(fullLink, { width: 300 });
                const qrImage = document.createElement('img');
                qrImage.src = qrDataURL;

                const printWindow = window.open('', '_blank');
                printWindow.document.open();
                printWindow.document.write(`<html><body>
                    <div id="qrCodeContainer" style="width: 5.98cm; height: 9cm; position: relative; border: 10px; border-style: double; text-align: center; box-shadow: inset 0px 0px 0px 5px #000; border-radius: 20px;">
                        <div style="  font-weight: 800; letter-spacing: 2px;
                text-shadow: 2px 2px 4px rgba(0,0,0,0.3); font-size: 30px; border-style: solid; border-width: 5px; border-color: #000; color: #000;"> สปภ. </div>
                        <img src="${qrDataURL}" alt="QR Code" style="width: 90%; "/>
                        <div class="code-label" style="margin-top: 10px; padding-top: 10px; padding-bottom:10px; font-size: 40px; border-style: solid; border-width: 5px; border-color: #000; color: #000;">${code}</div>
                    </div>
                </body></html>`);
                printWindow.document.close();

                setTimeout(() => {
                    printWindow.print();
                    printWindow.close();
                }, 500);
            } catch (error) {
                console.error('Failed to generate QR code:', error);
            }
        },

        setCurrentLocation() {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        const currentLatLon = {
                            lat: position.coords.latitude,
                            lon: position.coords.longitude
                        };
                        // Optionally, update local data properties
                        this.latlon = currentLatLon;
                        this.ifh_lat = currentLatLon.lat.toFixed(6);
                        this.ifh_lon = currentLatLon.lon.toFixed(6);
                        this.inputMap_latlon();
                        this.displayMap = false;

                        setTimeout(() => {
                            this.displayMap = true;
                        }, '100');
                    },
                    (error) => {
                        setTimeout(() => {
                            this.displayMap = true;
                        }, '1000');
                        alert('Error obtaining location: ' + error.message);
                    }
                );
            } else {
                alert('Geolocation is not supported by this browser.');
            }
        },

        chackDisableType() {
            if (this.temp) {
                return true;
            } else {
                return false;
            }
        }
    },

    computed: {
        isAdmin() {
            const permissId = this.getUserPermiss();
            return ['pl-000001'].includes(permissId);
        },
        filteredOrganizeTypeOptions() {
            if (!this.organizeTypeOptions_Form) return [];
            return this.organizeTypeOptions_Form.filter((option) => option.system_name && option.system_name.includes('สำนักงานเขต'));
        },
        showMobileDetailsView() {
            return this.$route.query.code && this.isMobile && !this.isLoggedIn;
        }
    },

    async mounted() {
        this.searchInputRef = this.$refs.searchInput?.$el || this.$refs.searchInput;
        this.initialCommunityData();
        this.checkLoginStatus();
        this.updateIsMobile();
        window.addEventListener('resize', this.updateIsMobile);
        EventBus.$on('user-logged-in', this.onUserLoggedIn);

        if (this.$route.query.code) {
            if (!this.isLoggedIn) {
                if (!this.isMobile) {
                    EventBus.$emit('show-login-modal-from-route');
                }
            } else {
                await this.handleQrCodeSearch(this.$route.query.code);
            }
        }
    },
    beforeDestroy() {
        EventBus.$off('user-logged-in', this.onUserLoggedIn);
        window.removeEventListener('resize', this.updateIsMobile);
    }
};
</script>

<style scoped>
.extinguisher-login-required-card {
    max-width: 450px;
    margin: 2rem auto;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.login-required-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 2rem 1rem;
    text-align: center;
    color: #666;
    font-size: 1rem;
}

.btnNow {
    position: absolute;
    top: 70px;
    left: 7px;
    color: black;
    background-color: white;
    z-index: 400;
    border-color: #ccc;
}
.btnNow:hover {
    color: black;
    border-color: #e4e4e4;
    background-color: #e4e4e4;
}
@media print {
    body * {
        visibility: hidden;
        /* Hide everything on the page when printing, except the QR code container */
    }

    #qrCodeContainer,
    #qrCodeContainer * {
        visibility: visible;
    }

    #qrCodeContainer {
        position: absolute;
        left: 0;
        top: 0;
        width: 6.98cm;
        height: 8.23cm;
        display: block !important;
        /* Override any 'display: none' */
    }
}

.qr-container {
    position: relative;
    width: fit-content;
    padding: 20px;
    background: #fff;
    /* border: 17px; */
    /* border-style: double; */
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
    text-align: center;
    margin-top: 50px;
    box-shadow: inset 0px 0px 0px 17px #000;
    border-radius: 10px;
}
.qr-code {
    width: 300px;
    height: 300px;
    border-style: solid;
    border-width: 10px;
    border-color: #000;
    border-radius: 10px;
}
.code-label {
    margin-top: -20px;
    padding-top: 10px;
    font-size: 40px;
    /* font-weight: bold; */
    border-style: solid;
    border-width: 10px;
    border-color: #000;
    border-radius: 10px;
    color: #000;
}

#preview {
    display: flex;
    justify-content: center;
    align-items: center;
}

.imgDia {
    width: 100%;
    display: block;
}

#preview img {
    /* height: 180px; */
    width: 234px;
    border: solid 1px #cccccc;
}

/*   Doe เพิ่มหมุด map V.2 9/9  --> */
.warningLATLON {
    color: rgb(225, 144, 13);
    font-size: 0.9rem;
}
/*   Doe เพิ่มหมุด map V.2 9/9  จบ--> */
.table_row {
    text-align: center;
}

@media screen and (min-width: 819px) and (max-width: 1200px) {
    #Search {
        width: 20rem;
    }
}
/* @media screen and (min-width: 538px){
      #Create{
      width: 146px;
    }
   
} */
#text_Foote {
    font-size: 1.2rem;
}
#Create {
    width: 149px;
}
#EX {
    width: 149px;
}
#PDF {
    width: 149px;
}
#TABLE_EDIT {
    width: 149px;
}
@media screen and (max-width: 991px) {
    #text_Footer {
        font-size: 1rem;
    }
}
@media screen and (max-width: 818px) {
    #Search {
        width: 100%;
    }
}

@media screen and (max-width: 430px) {
    #Create {
        width: 50%;
    }
    #EX {
        width: 50%;
    }
    #PDF {
        width: 55%;
    }
    #TABLE_EDIT {
        width: 45%;
    }
    .EV_disasterOptions {
        width: 16.75rem;
        overflow-y: scroll;
    }
    .EV_disasterOptions::-webkit-scrollbar {
        width: 0;
        height: 1px;
    }

    .EV_disasterOptions::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    }

    .EV_disasterOptions::-webkit-scrollbar-thumb {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
    }
}

.p-field {
    margin-bottom: 0rem;
}
</style>

<style>
@keyframes p-progress-spinner-color {
    100%,
    0% {
        stroke: #75e9f4;
    }
    40% {
        stroke: #0057e7;
    }
    66% {
        stroke: #75e9f4;
    }
    80%,
    90% {
        stroke: #0057e7;
    }
}
.p-datatable-thead {
    border: 2px solid #d6d6d6;
}

.p-datatable-tbody {
    border: 2px solid #d6d6d6;
}
</style>

<style scoped lang="scss">
:deep(.p-datatable-wrapper table) {
    border-left: 1px solid #d6d4d4;
    border-right: 1px solid #d6d4d4;
    border-collapse: separate;
    border-spacing: 0;
}
:deep(.p-datatable-scrollable-header-table) {
    background-color: #d6d4d4;
}
:deep(.p-datatable-wrapper) {
    max-height: 550px;
    overflow: auto;
}

:deep(.p-dialog) {
    @media screen and (max-width: 991px) {
        .p-dialog-content {
            overflow-y: auto;
        }
    }
}

.p-multiselect {
    min-width: 15rem;
}

.multiselect-custom {
    // Doe PDF เลือกได้
    width: 100%;
    .p-multiselect-label:not(.p-placeholder) {
        padding-top: 0.25rem;
        padding-bottom: 0.25rem;
    }

    .item {
        display: flex;
        align-items: center;
    }

    .item-value {
        padding-left: 10px;
        padding-right: 10px;
        border-radius: 3px;
        display: inline-flex;
        margin-right: 0.5rem;
        background-color: var(--primary-color);
        color: var(--primary-color-text);
    }
}
</style>
